export default {
  /* - Menu - */
  section_title_dashboard: 'Painel',
  section_title_users: 'Utilizadores',
  section_title_transactions: 'Transacções',
  section_title_customers: 'Clientes',
  section_title_office_users_list: 'Utilizadores',
  section_title_active_users: 'Utilizadores',
  section_title_archived_users: 'Utilizadores',
  section_title_superadmin_users: 'Utilizadores',
  section_title_active_customers: 'Clientes',
  section_title_transactions_charged: 'Transacções',
  section_title_transactions_declined: 'Transacções',
  section_title_transactions_authorizations: 'Transacções',
  section_title_transactions_history: 'Transacções',
  section_title_transactions_alternate_label: 'Transacções de equipa',
  section_title_reimbursements_alternate_label: 'Despesas da equipa',
  section_title_budgets: 'Orçamentos',
  section_title_budget_expense_evolution: 'Orçamentos',
  section_title_budgets_reimbursements: 'Orçamentos',
  section_title_budgets_active: 'Orçamentos',
  section_title_budgets_archived: 'Orçamentos',
  section_title_budget_members: 'Orçamentos',
  section_title_export_settings: 'Definição de exportação de dados',
  section_title_export: 'Exportação',
  section_title_export_create: 'Exportação',
  section_title_export_table_transactions: 'Exportação',
  section_title_export_table_expenses: 'Exportação',
  section_title_export_table_all: 'Exportação',
  section_title_export_exported: 'Exportação',
  section_title_user_profile_detail: 'Perfil',
  section_title_user_preferences: 'Preferências',
  section_title_user_overview: 'Visão geral',
  section_title_user_cards: 'Utilizadores',
  section_title_user_transactions: 'Utilizadores',
  section_title_user_budgets: 'Utilizadores',
  section_title_user_benefits: 'Utilizadores',
  section_title_user_reimbursements: 'Utilizadores',
  section_title_superadmin_massive_import_details:
    'Carregamento em massa de utilizadores',
  section_title_cards: 'Cartão',
  section_title_budget_cards: 'Cartão',
  section_title_virtual_cards: 'Cartão',
  section_title_physical_cards: 'Cartão',
  section_title_budgets_transactions: 'Orçamentos',
  section_title_transactions_pending: 'Transacções',
  section_title_logs: 'Logs',
  section_title_office_log: 'Logs',
  section_title_cards_log: 'Logs',
  section_title_user_log: 'Logs',
  section_title_webhook_log: 'Logs',
  section_title_company: 'Configurações',
  section_title_company_details: 'Configurações',
  section_title_transaction_fields: 'Configurações',
  section_title_expense_fields: 'Definições',
  section_title_integrations: 'Definições',
  section_title_integration_detail: 'Definições',
  section_title_profile: 'Perfil',
  section_title_benefits: 'Benefícios',
  section_title_benefits_users: 'Benefícios',
  section_title_benefit_transactions: 'Benefícios',
  section_title_social_benefits: 'Benefícios',
  section_title_merchants_settings: 'Configurações dos comerciantes',
  section_title_activity_group_settings: 'Configurações dos comerciantes',
  section_title_reimbursements: 'Despesas',
  section_title_reimbursements_pending: 'Despesas',
  section_title_reimbursements_history: 'Despesas',
  section_title_expenses: 'Minhas despesas',
  section_title_my_virtual_cards: 'Os meus cartões',
  section_title_my_physical_cards: 'Os meus cartões',
  section_title_my_history_reimbursements: 'Minhas despesas',
  section_title_my_history_reimbursements_breadcrumb: 'Histórico das despesas',
  section_title_my_charged_transactions: 'Minhas transacções',
  section_title_my_charged_transactions_breadcrumb: 'Transacções cobradas',
  section_title_my_authorizations_transactions: 'As minhas transacções',
  section_title_my_authorizations_transactions_breadcrumb: 'Autorizações',
  section_title_my_declined_transactions: 'As minhas transacções',
  section_title_my_declined_transactions_breadcrumb: 'Transacções negadas',
  section_title_my_pending_reimbursements: 'Minhas despesas',
  section_title_my_pending_reimbursements_breadcrumb: 'Pendente revisão',
  section_transaction_hover:
    'Aqui são apresentadas as transacções do mês corrente',
  section_title_my_transactions: 'Ninhas transacções',

  section_title_my_reimbursements: 'Minhas despesas',
  section_title_my_cards: 'Os meus cartões',
  section_title_all_cards: 'Cartões de equipa',

  /* - Termos comuns - */
  USERNAME: 'Insira o seu e-mail de utilizador',
  USERNAME_EMAIL: 'E-mail de utilizador',
  EMAIL: 'E-mail',
  EXPENSE_CENTER: 'Centro de despesas',
  EXPENSE_CENTER_PLACEHOLDER: 'Centro de despesas (opcional)',
  IDENTIFIER: 'Identificador',
  IDENTIFIER_PLACEHOLDER: 'Identificador (opcional)',
  DATE_OF_BIRTH: 'Data de nascimento',
  WORK_EMAIL_PLACEHOLDER: 'O seu e-mail de trabalho',
  PASSWORD: 'Palavra-passe',
  PASSWORD_PLACEHOLDER: 'Criar uma palavra-passe',
  REPEAT_PASSWORD: 'Repetir palavra-passe',
  REPEAT_PASSWORD_PLACEHOLDER: 'Repita a sua Nova Palavra-Passe',
  CURRENT_PASSWORD: 'Palavra-Passe Actual',
  NEW_PASSWORD: 'Nova Palavra-Passe',
  REPEAT_NEW_PASSWORD: 'Repita a sua Nova Palavra-Passe',
  NAME: 'Nome',
  NAME_PLACEHOLDER: 'O seu nome',
  FIRST_NAME: 'Primeiro nome',
  LAST_NAME: 'Apelido',
  LAST_NAME_PLACEHOLDER: 'O seu apelido',
  PHONE_NUMBER: 'Telefone',
  MOBILE_PHONE_NUMBER: 'Telemóvel',
  PHONE_PREFIX: 'Prefixo',
  PASSCODE: 'Chave',
  CITY: 'Cidade',
  ADDRESS: 'Endereço',
  ADDRESS_PLACEHOLDER: 'Rua, número, andar, porta...',
  ZIP: 'Código Postal',
  STATE: 'Província',
  ROLES: 'Função',
  COUNTRY: 'País',
  USERS_KEYWORD: 'Utilizadores',
  OTP: 'Password de uma utilização',
  CURRENCY: 'Divisa',
  STATUS: 'Estado',
  USER: 'Utilizador',
  BUDGETS: 'Orçamento',
  MEMBERSHIP_STATUS: 'Membro',
  ROLE_ADMIN: 'Administrador',
  ROLE_ADMIN_OWNER: 'Account holder',
  ROLE_ACCOUNT_HOLDER: 'Account holder',
  ROLE_BOOKKEEPER: 'Contabilista',
  ROLE_REGULAR: 'Normal',
  ROLE_COMMERCIAL: 'Comercial',
  ROLE_SUPER_BOOKKEEPER: 'Super contabilista',
  ROLE_BUDGET_OWNER: 'Proprietário do orçamento',
  FORGOT_PASSWORD: 'Esqueci-me da password',
  FILTERS: 'Filtros',
  COLUMNS: 'Colunas',
  FILTER_FROM: 'De',
  FILTER_TO: 'Para',
  FILTER_AMOUNT_FROM: 'Quantidade de',
  FILTER_AMOUNT_TO: 'Quantidade para',
  IMPERSONATE_BAR_TEXT:
    'Está a copiar: {userName} {userLastName} <email: {email}>',
  OFFICE_INFORMATION: 'Informação sobre a empresa',
  OFFICE_TOTAL_EMPLOYEES: 'Núm.de empregados',
  OFFICE_USERS_TO_INVOICE: 'Núm. mínimo a facturar',
  ACTION_IMPERSONATE_STOP: 'Parar a cópia',
  ACTIONS_LABEL: 'Acções',
  ACTION_EDIT: 'Editar',
  ACTION_SAVE: 'Guardar',
  ACTION_SAVE_CHANGES: 'Guardar cambios',
  ACTION_DELETE: 'Arquivo',
  ACTION_REMOVE: 'Apagar',
  ACTION_REMOVE_ALT: 'Apagar',
  ACTION_RESTORE: 'Restaurar',
  ACTION_CREATE: 'Criar',
  ACTION_CONTINUE: 'Continuar',
  ACTION_ACCEPT: 'Aceitar',
  ACTION_REJECT: 'Rejeitar',
  ACTION_SEND: 'Enviar',
  ACTION_SENDING: 'A enviar...',
  ACTION_UPDATE: 'Actualização',
  ACTION_GO_BACK: 'Regressar',
  ACTION_LOGIN: 'Iniciar sessão',
  ACTION_LOGOUT: 'Sair da sessão',
  ACTION_LOAD_MORE: 'Carregar mais',
  ACTION_SEARCH: 'Pesquisa...',
  ACTION_CLEAR: 'Eliminar',
  ACTION_FILTER: 'Filtrar',
  ACTION_CHECK: 'Ver...',
  ACTION_SIGN_UP: 'Registar',
  ACTION_SIGN_UP_ACCOUNT: 'Criar conta',
  ACTION_DOWNLOAD: 'Descarregar',
  ACTION_EXPORT_IN_PROGRESS: 'Exportar...',
  ACTION_COPY_TO_CLIPBOARD: 'Copiado',
  ACTION_CONFIRM: 'Confirmar',
  ACTION_CANCEL: 'Cancelar',
  ACTION_READ_MORE: 'Ler mais',
  ACTION_BILL_CLIENT: 'Recolher',
  ACTION_CONTACT_US: 'Contacte-nos',
  ACTION_RELOAD: 'Recarregar página',
  ACTION_CLICK_HERE: 'Clique aqui',
  ACTION_ADD_RECEIPT: 'Adicionar recibo',
  ACTION_NEXT_STEP: 'Próximo',
  ACTION_RETURN_TO_LOGIN: 'Regressar para iniciar sessão',
  ACTION_REINVITE: 'Reenviar convite',
  ACTION_REINVITING: 'Reenvio de convite',
  ACTION_ALSO_CLOSE: 'Também fechar',
  RET_FLEX_KEY: 'Remuneração flexível',
  BENEFITS_KEY: 'Beneficios sociais',
  DEVOLUIVA_KEY: 'Devoluiva',
  MULTISELECT_DEFAULT_SELECT_LABEL: 'Seleccionado',
  MULTISELECT_DEFAULT_SELECTED_LABEL: 'Seleccionado',
  MULTISELECT_DEFAULT_DESELECT_LABEL: 'Remover Selecção',
  MULTISELECT_DEFAULT_NO_OPTIONS: 'Não há opções disponíveis',
  MULTISELECT_DEFAULT_NO_RESULTS: 'Não foram encontrados resultados',
  MULTISELECT_OPTION_LABEL_ALL: 'Todos',
  MULTISELECT_OPTION_LABEL_RECENT: 'Recentemente utilizados',

  G_AUTOCOMPLETE_DEFAULT_PLACEHOLDER: 'Introduzir país, cidade ou rua...',
  SUPPORT_EMAIL: 'customer.support@getfuell.com',
  OR_KEYWORD: 'O',
  ACTION_DOWNLOAD_APP: 'Ainda não tem a app?',
  AND: 'e',
  ID: 'ID',
  /* ----- ---------------LOGIN */

  login_welcome_fuell: 'Entre com a sua conta',
  login_download_apps: 'Descarregar app',

  login_action_login_snackbar_error: 'Ups! Algo correu mal ao tentar entrar ',
  login_action_accept_invitation_success:
    'Está feito! Descarregar a aplicação para começar a negociar com a Fuell',
  login_action_accept_invitation_error:
    'Ups! Algo correu mal ao tentar aceitar o convite: ',
  login_action_request_reset_password_info:
    'Pediu para redefinir a sua palavra-passe. Verifique o seu e-mail e siga as instruções',
  login_action_request_reset_password_error:
    'Ups! Algo correu mal ao tentar redefinir a sua palavra-passe: ',
  login_action_reset_password_success:
    'A sua palavra-chave foi actualizada com sucesso',
  login_action_reset_password_error:
    'Ups! Algo correu mal ao tentar redefinir a sua palavra-passe: ',
  login_action_impersonate_user_info:
    'Está a fazer-se passar por utilizador: {user}',
  login_action_impersonate_user_error:
    'Ups! Algo correu mal ao tentar personificar o utilizador:',
  login_action_stop_impersonation_info: 'A personificação está completa',
  login_already_a_user_redirect: 'Já tem uma conta?',
  login_already_a_user_redirect_login_link: 'Iniciar sessão',
  login_action_login_snackbar_error_invalidad_credentials:
    ' Ups! Algo correu mal ao tentar iniciar sessão: Nome de utilizador ou palavra-passe incorrectos',

  login_change_passcode_form_submit: 'Alterar o código de acesso',
  login_change_passcode_action_change_passcode: 'Alterar o código de acesso',
  login_change_passcode_action_return_to_dashboard:
    'Voltar ao painel principal',
  login_change_passcode_form_information:
    'Olá {userName}, para alterar a sua palavra-passe, preencha a informação solicitada',
  login_change_passcode_input_new_passcode:
    'Introduza a sua nova palavra-passe',
  login_change_passcode_input_repeat_passcode: 'Volte a introduzir a nova palavra-passe',
  login_change_passcode_invalid_token_error:
    'Não é possível alterar a palavra-passe, é necessário ter sessão iniciada com o utilizador que solicitou a alteração ou a ligação para alterar o código pode ter expirado.',
  login_change_passcode_success_with_redirect:
    'A senha foi alterada com sucesso, será redireccionado para o painel principal em breve',
  user_request_reset_passcode_success:
    'Enviámos-lhe um e-mail para alterar a sua palavra-passe',
  /**/
  /* - Lembrar palavra-passe - */
  login_password_rem_button: 'Esqueceu-se da sua palavra-passe?',
  login_password_rem_greeting: 'Reponha a sua palavra-passe',
  login_password_rem_sent: 'Verifique o seu e-mail',
  login_password_rem_error: 'O e-mail que introduziu não está registado',
  login_reset_password_form_submit: 'Alterar palavra-passe',
  login_forgot_password_instructions:
    'Preencha os seus dados e nós enviar-lhe-emos instruções sobre como redefinir a sua palavra-passe',
  /* -- DASHBOARD -- */
  dashboard_user_greeting: 'Olá, {user}!',
  dashboard_balance_card_title: 'Saldo',
  dashboard_balance_available: 'Disponível',
  dashboard_balance_withheld: 'Retido',
  dashboard_balance_card_wiretransfer_recharge: 'Completar por transferência',
  dashboard_balance_card_fast_recharge: 'Carregamento rápido',
  dashboard_account_box_available: 'saldo actual',
  dashboard_account_box_statment_period: 'Período de facturação',
  dashboard_account_box_payment_cycle: 'Ciclo de pagamento',
  dashboard_account_box_payment_cycle__monthly: 'Mensal',
  dashboard_account_box_payment_due_date: 'Data de pagamento',
  dashboard_account_box_make_payment_action: 'Adicionar dinheiro',
  dashboard_account_box_make_payment_wire_transfer_title:
    'Adicionar dinheiro por transferência',
  dashboard_account_box_payment_history_action:
    'Histórico de carregamento e facturas',

  dashboard_account_box_movements_header: 'Histórico da carregamento',
  dashboard_movements_modal_zero_results: 'Sem informação de carregamento',
  dashboard_account_box_make_payment_text_1:
    'Acrescentar dinheiro fazendo uma transferência de qualquer banco com os seguintes detalhes.',
  dashboard_account_box_make_payment_text_2:
    'Recomendamos uma transferência mensal regular. Demorará 24h-48h',
  dashboard_account_box_make_transfer_fetch_info_error: 'Não conseguimos obter os detalhes para a transferência bancária, por favor tente novamente mais tarde.',
  dashboard_account_box_make_card_payment_text:
    'Adicionar dinheiro imediatamente, utilizando um cartão empresarial, emitido por qualquer banco.',
  dashboard_make_payment_bank_account: 'Número de conta bancária:',
  dashboard_make_payment_bank_transfer_subject: 'Descrição',
  dashboard_make_payment_bank_account_holder: 'Destinatário:',
  dashboard_make_payment_bank_swift_code: 'Código swift',

  dashboard_card_payment_title: 'Recarga rápida',
  dashboard_card_create_and_payment_button: 'Acrescentar cartão e recarregar',
  dashboard_card_payment_button: 'Recarregar',
  dashboard_card_payment_your_balance_will_be: 'O seu saldo será',
  dashboard_card_payment_add_card: 'Novo cartão',
  dashboard_card_payment_save_card: 'Guardar cartão',
  dashboard_card_payment_selected_card: 'Cartão seleccionado',
  dashboard_card_payment_selected_card_placeholder: 'Seleccione um cartão',
  dashboard_card_payment_selected_card_no_cards: 'Sem cartões',
  dashboard_card_payment_selected_card_no_results:
    'Não existem cartões para a pesquisa actual',

  dashboard_card_payment_faq: 'Verifique {link} os limites para carregamentos rápidos',
  dashboard_card_payment_faq_link: 'https://www.notion.so/factorialco/Haz-recargas-en-Fuell-12d0a6c82b3a4c24a481edeb2ed3881e',
  dashboard_card_payment_faq_click_here: 'aquí',
  dashboard_make_card_payment_modal_delete_card_confirm: 'O cartão com os últimos 4 dígitos {cardLastDigits} será apagado, carregar em Retirar cartão para confirmar ou cancelar a devolução.',
  dashboard_make_card_payment_modal_delete_card_confirm_header: 'Retirar cartão',

  dashboard_card_payment_error: 'Ups! Algo correu mal com o pagamento',
  dashboard_card_payment_success_title: 'Dinheiro pago!',
  dashboard_card_payment_failed_title: 'Houve um erro',
  dashboard_card_payment_success_message: 'O seu saldo é',
  dashboard_card_payment_failed_message: 'O saldo não pôde ser creditado.',
  dashboard_card_payment_failed_support: 'Contacte o suporte para mais informações',
  dashboard_card_payment_failed_reasons: 'Os limites de recarga podem ter sido excedidos:',
  dashboard_card_payment_failed_reasons_1: 'Cartão por dia: 3,000€',
  dashboard_card_payment_failed_reasons_2: 'Empresa por dia: 5.000€',
  dashboard_card_payment_failed_reasons_3: 'Empresa por 7 dias de calendário: 6.000€',
  dashboard_card_payment_failed_reasons_4: 'Empresa para os 30 dias de calendário anteriores: 9.000€',

  dashboard_card_payment_make_payment_invalid_amount:
    'Por favor, introduza um montante superior a 0 para continuar.',
  dashboard_card_payment_make_payment_invalid_card:
    'Por favor seleccione um cartão ou a opção Novo cartão para continuar.',

  dashboard_top_up_history_action_download_invoice: 'Descarregar factura',
  office_fetch_issuer_balance_error:
    'Ups! Algo correu mal ao tentar obter a informação do saldo.',
  dashboard_fetch_movements_error:
    'Ups! Algo correu mal ao tentar obter o histórico do movimento.',
  dashboard_download_invoice_error:
    'Ups! Algo correu mal ao tentar descarregar a factura',
  office_fetch_tokenized_cards_error:
    'Ups! Algo correu mal ao tentar obter os cartões guardados.',
  office_delete_tokenized_cards_error:
    'Ups! Algo correu mal ao tentar apagar o cartão guardado.',
  /* - Dashboard graphic keys - */
  dashboard_graphic_header: 'Tendências das despesas',
  dashboard_graphic_header_budgets: 'Evolução das despesas (por orçamento)',
  dashboard_graphic_header_categories: 'Evolução das despesas (por categoria)',
  dashboard_graphic_merchant_filter: 'Filtrar por comércio',
  dashboard_graphic_date_selector_filter: 'Filtrar por período',
  dashboard_selector_group_by: 'Agrupar por:',
  dashboard_graphic_group_selector_delimited_by_expense_type: 'Despesas totais',
  dashboard_graphic_group_selector_delimited_by_budget: 'Despesas por orçamento',
  dashboard_graphic_group_selector_delimited_by_category: 'Despesas por categoria',
  dashboard_graphic_expenses_group_by_month: 'Despesa por mês',
  dashboard_graphic_expenses_group_by_day: 'Despesa por dia',
  dashboard_graphic_date_selector_filter_today: 'Hoje',
  dashboard_graphic_date_selector_filter_last_seven_days: 'Últimos 7 dias',
  dashboard_graphic_date_selector_filter_last_thirty_days: 'Últimos 30 dias',
  dashboard_graphic_date_selector_filter_last_year: 'Ano passado',
  dashboard_graphic_date_selector_filter_current_year:
    'Ano corrente (Janeiro até à data)',
  dashboard_graphic_date_selector_filte_custom_range:
    'Personalizar o intervalo de datas...',
  dashboard_graphic_group_selector_group_by_days: ' Agrupar por dias',
  dashboard_graphic_group_selector_group_by_month: 'Agrupar por mês',
  dashboard_time_selector_modal_header:
    'Seleccionar intervalo de datas personalizado',
  date_picker_input_range_selector: 'Intervalo de datas',
  dashboard_fetch_expense_dashboard_data_error:
    'Ups! Alguma coisa correu mal ao tentar obter os dados para os gráficos.',

  /* Dashboard insights keys */
  dashboard_insight_expense_word: 'Despesas incorridas',
  dashboard_insight_header_people: 'Despesa por empregado',
  dashboard_insight_header_mileage: 'Despesas de quilómetros',
  dashboard_insight_header_budgets: 'Despesa com orçamentos',
  dashboard_fetch_people_insight_error:
    'Ups! Algo correu mal ao tentar obter os custos por pessoa.',
  dashboard_fetch_mileage_insight_error:
    'Ups! Algo correu mal ao tentar obter as despesas de quilómetros.',
  dashboard_fetch_budget_insight_error:
    'Oops! Algo correu mal ao tentar obter os gastos por orçamentos.',
  dashboard_insight_card_table_header_name: 'Nome',
  dashboard_insight_card_table_header_spent_percentage: '% Gasto',
  dashboard_insight_card_table_header_spent_in_current_month: 'Despesa do mês',
  dashboard_insight_card_table_header_spent_percentage_change: '% Mudança',
  dashboard_insight_card_table_header_transactions_amount: 'Transacções',
  dashboard_insight_card_table_header_transactions_missing_info:
    'Falta infor.',
  dashboard_insight_card_table_header_transactions_not_reviewed:
    'Revisão em falta',
  dashboard_insight_card_table_no_data:
    'Ainda não temos dados de utilização para lhe mostrar, mas assim que forem gerados, aparecerão aqui!',
  dashboard_graphic_date_selector_range_from: 'a partir de',
  dashboard_graphic_date_selector_range_to: 'para',

  /* Dashboard tasks keys */
  dashboard_tasks_title: 'As suas tarefas',
  dashboard_team_tasks_title: 'Tarefas de equipa',
  dashboard_task_list_incomplete_tasks: 'Transacções a serem concluídas',
  dashboard_task_list_not_reviewed_tasks: 'Transacções a serem revistas',
  dashboard_task_list_incompleted_reimbursements_tasks:
    'Despesas para conclusão',
  dashboard_task_list_not_reviewed_reimbursements_tasks:
    'Despesas a serem revistas',
  dashboard_task_completed_title: 'Não tem nenhum assunto inacabado!',
  dashboard_task_completed_body: 'Concluiu todas as aprovações pendentes',
  dashboard_task_completed_body_navigate:
    'Bom trabalho! Pode clicar {link} para ver todas as suas despesas',
  dashboard_task_period_current_month: 'Mês corrente',
  dashboard_task_period_current_week: 'Esta semana',
  dashboard_task_period_current_quarter: 'Trimestre actual',
  dashboard_task_period_current_year: 'Este ano',
  dashboard_task_period_history: 'Histórico',
  dashboard_task_list_notification_link: 'Enviar notificação de tarefas pendentes',

  // NOTIFICATION TASKS MODAL
  send_notification_tasks_modal_title: 'Enviar notificação',
  send_notification_tasks_modal_message: 'Enviaremos uma notificação sua aos utilizadores com o tipo de tarefas pendentes que seleccionar.',
  send_notification_tasks_confirm_modal_message: 'Tem a certeza de que quer enviar notificações? Lembre-se que o abuso desta característica pode levar os empregados a ignorar os alertas.',
  send_notification_tasks_confirm_modal_message_send: 'Sim, enviar',
  send_notification_tasks_modal_message_radio_title: 'Tipo de notificação a enviar',
  send_notification_tasks_modal_message_radio_message: 'Seleccione a notificação que pretende enviar',
  send_notification_tasks_modal_radio_complete: 'Preencher as despesas em ',
  send_notification_tasks_modal_radio_review: 'Despesas de revisão',
  send_notification_tasks_modal_radio_complete_italic: 'Informação em falta',
  send_notification_tasks_modal_radio_review_italic: 'Revisão pendente',
  send_notification_tasks_modal_message_send: 'Enviar notificação',

  /* ------- USERS ---------- */
  users_invite_massive_upload: 'Subida acentuada',
  users_users_section_header: 'Utilizadores',
  users_user_export: 'Exportar utilizadores',
  users_user_export_file: 'Lista de utilizadores {exportDate}',

  users_user_signup_button: 'Convidar Utilizadores',
  users_invite_user: 'Convidar utilizador',
  users_add_user: '+ Adicionar Utilizador',
  users_expense_type_label: 'Forma de despesas do utilizador',
  users_expense_type_label_optional_cards: 'Pode decidir se o utilizador irá trabalhar com cartões virtuais, se deseja que lhe seja enviado um cartão físico ou se só poderá carregar as despesas para a plataforma manualmente.',
  users_expense_type_label_cards: 'Pode decidir se o utilizador só trabalhará com cartões virtuais ou se quer que um cartão físico seja enviado ao utilizador.',
  users_import_users: 'Importar Utilizadores',
  users_import_users_description:
    'Para fazer um convite em massa a toda a sua equipa {downloadLink}. Depois preencha-o com os seus dados e carregue-o de volta aqui.',
  users_import_optional_card_warning:
    'Por favor, verifique se preencheu todas as colunas do formulário. Caso não preencha as células da coluna "Emitir cartão?", o cartão física será emitido ao utilizador.',
  users_import_users_download_template: 'descarregar este modelo',
  users_import_invalid_file:
    'O ficheiro que seleccionou é inválido, por favor tente novamente utilizando o nosso modelo.',
  users_import_invalid_users:
    'Os seguintes utilizadores são inválidos, corrija o problema no ficheiro e volte a submeter para continuar.',
  users_import_violation_email_already_in_use: 'E-mail em uso',
  users_import_violation_invalid_email: 'Endereço de e-mail inválido',
  users_import_violation_no_name: 'Sem nome',
  users_import_violation_no_role: 'Sem função',
  users_import_violation_email_already_in_use_on_import:
    'E-mail repetido no arquivo',
  users_import_confirm_intro:
    'Estes são os dados que extraímos do ficheiro. Verifique se estão correctos e depois clique em continuar.',
  users_import_button_wrong_file: 'Tenho o ficheiro errado',
  users_import_table_name: 'Nome',
  users_import_table_email: 'Endereço de correio electrónico',
  users_import_table_issue: 'Problema',
  users_import_table_gross_salary: 'Salário bruto',
  users_import_table_role: 'Função',
  users_import_table_card_emission: 'Cartões',
  users_import_select_file_text:
    'Arraste aqui o seu ficheiro de utilizador ou clique para o seleccionar.',
  users_import_selected_file_intro:
    'Vamos processar o ficheiro e verificar se está tudo correcto.',
  users_import_invitations_sent:
    '✅ Os convites foram enviados aos utilizadores',
  users_import_invitations_waiting_approval:
    'Obrigado, estamos a processar o seu pedido.',
  users_import_invitations_waiting_approval_contact:
    'Contacte-nos por chat, se precisar de ajuda.',
  users_import_confirm_modal_message:
    'Serão adicionados {count} , dos quais {regular} são utilizadores normais e {bookkeeper} contabilistas.',
  users_import_loading_error: 'Ocorreu um erro ao carregar os dados',
  users_import_accept_error:
    'Ocorreu um erro ao criar os utilizadores ou ao enviar os convites.',
  users_import_accept_completed:
    'Os utilizadores foram criados e os convites foram enviados.',
  users_import_reject_error:
    'Ocorreu um erro ao rejeitar o carregamento de utilizadores.',
  users_import_reject_completed: 'O aumento dos utilizadores foi rejeitado',
  users_import_validation_description:
    'A empresa quer importar os seguintes utilizadores',
  users_import_already_completed:
    'O carregamento de utilizadores já terminou',
  users_tab_section_active: 'Activos',
  users_tab_section_archived: 'Arquivados',
  users_user_signup_section_send_invites: 'Enviar Convites',
  users_customers_admin_impersonate_customer_admin: 'Administrador Suplente',
  users_customers_admin_impersonate_user: 'Fingir-se de utilizador',
  users_user_invitation_request_card: 'Solicitar um cartão',
  user_status__INVITE_BY_SUPER_ADMIN: 'A ser activado',
  user_status__INVITE_BY_ADMIN: 'A ser activado',
  user_status__ACTIVE: 'Utilizador Activo',
  user_status__ARCHIVE: 'Utilizador Arquivado',
  user_status__DELETED: 'Utilizador Apagado',
  user_role__ROLE_ADMIN: 'Administrador',
  user_role__ROLE_ADMIN_OWNER: 'Account holder',
  user_role__ROLE_ACCOUNT_HOLDER: 'Account holder',
  user_role__ROLE_BOOKKEEPER: 'Contabilista',
  user_role__ROLE_REGULAR: 'Normal',
  user_role__ROLE_SUPER_ADMIN: 'Superadministrador',
  user_role__ROLE_COMMERCIAL: 'Comercial',
  user_role__ROLE_SUPER_BOOKKEEPER: 'Super contabilista',
  user_role_help_text: 'Qual é a função mais apropriada?',
  user_role_read_more: 'Ler mais.',
  /* - Customer Terms - */
  customers_tabs_customer: 'Clientes',
  customers_tabs_users: 'Utilizadores',
  customer_creation_header: 'Adicionar Cliente',
  customer_information_header: 'Sociedade',
  customer_creation_social_reason: 'Nome da empresa',
  customer_creation_social_or_billing_information:
    'Escritório registado / Endereço para facturação',
  customer_creation_office_configuration: 'Configuração da empresa',
  customer_creation_office_card_usage: 'Utilização de cartões para a empresa',
  customer_creation_zoho_pricing_plan: 'Plano de preços',
  customer_creation_zoho_pricing_plan_tooltip:
    'Seleccione o plano de preços para esta empresa. Estes planos devem ser previamente criados em Zoho para serem listados aqui. A informação será gerada em Zoho assim que o administrador da empresa completar o registo.',
  customer_creation_office_card_usage_tooltip:
    'Seleccionar se a empresa funcionará com cartões, sem cartões, ou dar aos administradores a possibilidade de decidir se os utilizadores utilizarão ou não o cartão da Fuell.',
  customer_creation_fuell_admin_data: 'Gestor de conta Fuell',
  customer_creation_fuell_admin_card_usage: 'Utilização do cartão',
  customer_creation_fuell_admin_card_type_emission: 'Tipo de cartão a emitir',
  customer_creation_fuell_admin_card_usage_tooltip:
    'Apenas se a empresa tiver um cartão opcional, seleccione se o administrador da empresa terá ou não um cartão',
  customer_creation_card_record: 'Gravação em cartões',
  customer_creation_card_company_name_on_record: 'Nome da empresa no cartão',
  customer_creation_card_send_address: ' Endereço para envio de cartões',
  customer_creation_office_other: 'Mais informações',
  customer_creation_invite_customer: 'Convidar',
  customer_update_customer_types: 'Actualizar a lista de preços',
  customer_creation_registration_number: 'Número de registo de IVA',
  customer_creation_office_admin_header: 'Detalhes do administrador',
  customer_creation_office_header: 'Dados do Gabinete',
  customer_creation_office_contact_person: 'Pessoa de contacto',
  customer_creation_office_board_members:
    'Membros do Conselho de Administração',
  customer_creation_office_current_balance: 'Saldo actual',
  customer_creation_office_balance_alert_threeshold:
    'Alerta de limite de despesas',
  customer_list_table_header_name: 'Nome da empresa Cliente',
  customer_list_table_header_registration_number: 'IVA',
  customer_list_table_header_customer_office_admin: 'Administrador',
  customer_list_table_header_customer_client_type: 'Tipo Cliente',
  customer_list_table_header_customer_office_admin_status: 'Estado de Admin.',
  customer_list_table_header_customer_card_usage_type: 'Emissão de cartões',
  customer_status_ACTIVE: 'Cliente Activo',
  customer_status_ARCHIVED: 'Cliente Arquivado',
  customer_actions_modal_header: 'Acções de Clientes',
  customer_actions_modal_customer_actions: 'Acções da empresa',
  customer_actions_modal_customer_information: 'Informações sobre a empresa',
  customer_onboarding_header: 'Onboarding',
  customer_onboarding_type__STANDARD: 'Normal',
  customer_onboarding_type__SELF_ONBOARD: 'Web',
  customer_onboarding_type__WITHOUT_CUSTOMER: 'App',

  customer_new_customer_user_to_invoice: 'Número mínimo de utilizadores a cobrar',
  customer_new_customer_billing_starts_at: 'Comece a facturar a partir de',
  customer_new_customer_billing_starts_at_placeholder: 'Seleccionar a data de início da facturação',
  customer_new_customer_devoluiva: 'Ativar a DevoluIVA para esta empresa',
  customer_new_customer_allow_shipping_address: 'Utilize este endereço para enviar todos os cartões a serem emitidos.',
  customer_new_customer_allow_shipping_address_info: 'e assinalar esta caixa, o utilizador não poderá seleccionar um endereço de entrega e todos os cartões chegarão a este endereço por defeito.',

  customer_creation_fuell_attorney_data: 'Procurador da conta',
  customer_new_customer_attorney_document: 'ID (DNI...)',
  customer_new_customer_attorney_date_of_birth: 'Data de nascimento',
  customer_convert_to_card_user_document_expiration_date: 'Data de expiração do bilhete de identidade',
  /* customer billing terms  */
  customers_bill_client_header: 'Colecções de clientes',
  customers_bill_client_amount: 'Quantidade',
  customers_bill_client_message:
    'Está prestes a fazer um pagamento ao cliente {customerName} introduza o montante e a sua palavra-passe para continuar.',
  customers_bill_client_action: 'Carregar cliente',

  customers_bill_client_success: 'Recolha correcta',
  customers_bill_client_error:
    'Ups! Tivemos um problema ao cobrar ao cliente.',
  customers_confirm_archive_header_action: 'Arquivo de clientes',
  customers_confirm_activate_header_action: 'Activar o cliente',
  customers_confirm_toggle_archive_customer_status:
    'Está prestes a arquivar o cliente {customerName}, para continuar selecione Arquivar cliente, caso contrário prima Cancelar.',
  customers_confirm_toggle_activate_customer_status:
    'Está prestes a activar o cliente {customerName}, para continuar selecione Activar cliente, caso contrário selecione Cancelar.',
  customers_user_actions_reequest_card: 'Pedido de envio de cartão',
  customers_user_cards: 'Cartões',
  customer_user_without_cards: 'Utilizador sem cartões',
  customer_user_with_virtual_cards: 'Utilizador com cartões virtuais',
  customer_user_request_physical_card: 'Solicitar um cartão físico',
  customer_user_convert_to_user_with_cards: 'Tornar-se um utilizador com cartões',

  customer_user_actions_cancel_card: 'Cancelar cartão com MP: {numMP}',
  customer_user_card_not_emmited: 'Não emitido',
  customers_users_request_card_action: 'Cartão de pedido',
  customers_users_request_card_info: 'Para solicitar um cartão para o utilizador {userName}, preencha as informações solicitadas e clique em Solicitar Cartão para continuar.',
  customers_users_request_card_no_sending_info: 'Para solicitar um cartão para o utilizador {userName}, clique em Solicitar Cartão para continuar.',

  customers_users_request_card_success: 'Cartão solicitado com sucesso',
  customers_users_request_card_summary_info: 'Está prestes a solicitar um cartão para o utilizador {userName}. {verify} e clique em Verificar Cartão para continuar. Se precisar de alterar a informação, prima Cancelar e edite.',
  customers_users_request_card_summary_info_verify: 'Verifique por favor se a informação está correcta',

  customers_users_request_card_error: 'Ups! Algo correu mal ao tentar pedir o cartão',

  customers_users_convert_to_card_user_header: 'Tornar-se um utilizador com cartões',
  customers_users_convert_to_card_user_info: 'Vai solicitar o registo do utilizador {userName} no Pecunpay para que este possa utilizar cartões, preencha as informações solicitadas e clique em Tornar-se utilizador de cartões para continuar.',
  customers_users_convert_to_card_user_submit: 'Tornar-se um utilizador com cartões',
  customers_users_convert_to_card_user_summary_info: 'Está prestes a converter o utilizador {userName} num utilizador com cartão. {verificar} e prima Converter em utilizador com cartão para continuar. Se precisar de alterar as informações, prima Cancelar e edite-as.',
  customers_users_convert_to_card_user_summary_info_verify: 'Verificar se as informações estão correctas',

  customers_users_convert_to_cards_user_success: 'O pedido de registo do utilizador no Pecunpay foi enviado.',
  customers_users_conver_to_cards_user_error: 'Ops! Algo correu mal quando tentei registar-me como utilizador no Pecunpay.',

  customers_users_actions_cancel_card_confirm: 'Está prestes a cancelar o cartão de utilizador {userName}, com número MP, {numMP}. Esta acção não pode ser desfeita, se quiser continuar, prima Cancelar Cartão para continuar, ou Cancelar para voltar',
  customers_users_actions_cancel_card_confirm_action: 'Cancelar cartão',
  customers_users_actions_cancel_card_success: 'Cartão cancelado com sucesso',
  customers_users_actions_cancel_card_error: 'Ups! Algo correu mal ao tentar cancelar o cartão',
  customer_actions_request_otp: 'Para esta acção, é necessário solicitar uma Palavra-Chave Temporária (OTP). Quando a solicitar, irá receber uma palavra-passe única no seu telefone para confirmar a acção. Escreva-a e carregue em confirmar',
  customer_actions_request_otp_action: 'Pedir OTP',
  customer_actions_request_otp_warning: 'Se demorar mais de um minuto a receber a OTP, solicite-a novamente pressionando Solicitar OTP',
  customer_actions_request_otp_in_progress: 'Gerar OTP, verifique as SMS...',
  customer_actions_otp_requested_warning: 'Foi-lhe enviada uma senha por SMS, utilize-a para validar a operação. Se não a tiver recebido, por favor solicite-a novamente.',
  customer_action_remove_users: 'Eliminar todos os utilizadores',
  customers_action_remove_users_confirm_modal_title: 'Confirmar a eliminação de todos os utilizadores',
  customers_action_remove_users_confirm_modal_body: 'Todos os utilizadores da empresa serão eliminados. Quando tiver terminado, receberá um e-mail a confirmar o resultado da operação. Clique em confirmar para continuar.',
  customer_remove_users_action_success: 'A remoção de todos os utilizadores foi corretamente solicitada.',
  customer_remove_users_action_error: 'Ops! Tivemos um problema ao solicitar a eliminação de utilizadores.',

  /* Customer Funds Transfer terms */
  customer_action_transfer_funds: 'Transferência bancária de fundos',
  customer_action_transfer: 'Fazer um retorno',
  customer_action_manage_office_features: 'Gerir características',
  customer_action_archive: 'Arquivar empresa',
  customer_action_restore: 'Restaurar empresa',
  customers_funds_transfer_modal_header:
    'Transferir de fundos para conta bancária',
  customers_funds_transfer_modal_confirm_transfer: 'Transferir fundos',

  customers_transfer_funds_to_bank_account_message:
    'Vai transferir fundos da conta do cliente {customerName} para uma conta bancária através do seu número IBAN, preencher as informações e carregar em enviar.',
  customer_amount_to_transfer: 'Montante da transferência',
  customer_transfer_concept: 'Descrição',
  customer_transfer_iban_bank_number: 'Número IBAN da conta de destino',
  customer_transfer_beneficiary_name: 'Nome do beneficiário',
  /* - Customer  office Feauture Activation */
  customer_data_error: 'Tivemos um problema ao obter informações sobre o cliente',
  office_features_activation: 'Activar características',
  office_feature_activate_rf: 'Activar a Remuneração Flexível',
  office_feature_activate_benefits: 'Activar o Benefício Social',
  office_feature_activate_devoluiva: 'Activar Devoluiva',
  office_feature_rf_activated: 'Remuneração flexível activada',
  office_feature_bf_activated: 'Benefícios sociais activados',
  office_feature_devoluiva_activated: ' Devoluiva activada',
  office_feature_activate_rf_header: 'Activar a Remuneração Flexível',
  office_feature_warning:
    'Está prestes a activar a funcionalidade {featureName}, para a empresa {customerName}. {featureWarningDanger}, por isso é favor confirmar os detalhes da empresa a activar e carregar em confirmar.',
  office_feature_warning_danger:
    'Esta característica não pode ser facilmente desactivada.',
  office_feature_activation_success:
    'A funcionalidade foi activada correctamente',
  office_feature_feature_not_found_error:
    'A funcionalidade a activar não foi encontrada, por favor tente novamente mais tarde.',
  office_feature_activation_error:
    'Ups! Tivemos um problema ao tentar activar esta funcionalidade',
  confirm_save_changes_modal: 'Guardar alterações',
  confirm_save_changes_modal_message: 'Tem a certeza de que quer guardar as alterações? Esta configuração irá afetar toda a empresa',
  confirm_close_save_changes_modal: 'Fechar a janela',
  confirm_close_save_changes_modal_message: 'Tem a certeza de que quer fechar a janela? As alterações efectuadas não serão aplicadas',
  /* --- */

  manage_office_features_header: 'Gerir características',
  manage_office_feature_FLEXIBLE_REMUNERATION: 'Remuneração flexível',
  manage_office_feature_EXPORT_FUNNEL_FEATURE: 'Exportação personalizada',
  manage_office_feature_SUBVENTION_FEATURE: 'Benefícios sociais',

  manage_office_feature_MULTI_CURRENCIES_FEATURE: 'Multimoeda',
  manage_office_feature_WATERMARK: 'Marca de água',
  manage_office_feature_OWNER_INVITE_USER: 'Os proprietários do orçamento podem convidar',
  manage_office_feature_AUTO_EXCHANGE: 'Troca automática',
  manage_office_feature_AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION: 'A edição não reinicia a revisão',
  manage_office_feature_DEVOLUIVA: 'DevoluIVA',
  manage_office_feature_MANUAL_EXPENSES_REIMBURSE: 'Permitir a criação de devoluções',
  manage_office_feature_SHOW_BUDGET_FIELDS: 'Adicionar campos orçamentais adicionais',

  manage_office_feature_tooltip_AUTO_EXCHANGE: 'Quando ativado, o valor da despesa e o valor na moeda original têm sempre a informação do que o OCR lê',
  manage_office_feature_tooltip_AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION: 'Se ativado, quando uma despesa é editada e está num fluxo de aprovação, não é devolvida ao primeiro passo do fluxo de aprovação',
  manage_office_feature_tooltip_MANUAL_EXPENSES_REIMBURSE: 'Ao activá-la, as empresas terão a possibilidade de criar reembolsos manualmente ao criar uma despesa.',

  /* - Users Terms  - */
  users_identifier: 'Identificador',
  users_expense_center: 'Centro de dispesa',
  users_physical_card_status: 'Estado Cartão Físico',
  users_budgets: 'Orçamentos',
  user_dni: 'DNI',
  user_list_table_header_invited_on: 'Data de convite',
  user_list_table_header_flexible_retribution: 'Ret. Flex. Refeição',
  user_list_table_header_gross_salary: 'Salário anual bruto',
  users_create_commercial: 'Criar comercial',
  users_superadmin_create_commercial_modal_header: 'Criação de comercial',
  users_superadmin_create_commercial_action_create: 'Criar comercial',
  users_superadmin_create_commercial_success:
    'O comercial foi criado com êxito',
  users_superadmin_create_commercial_error:
    'Ups! Encontrámos um problema quando tentámos criar o utilizador comercial',
  users_create_super_book_keeper: 'Criar super contabilista',
  users_superadmin_create_super_book_modal_header:
    'Criação de utilizador super contabilista',
  users_superadmin_create_superbook_action_create: 'Criar super contabilista',
  users_superadmin_create_superbook_success:
    'O super contabilista foi criado correctamente',
  users_superadmin_create_superbook_error:
    'Ups! Tivemos um problema ao tentar criar o super contabilista',
  /* -  User Details  - */
  user_detail_action_edit_profile: 'Editar Perfil',
  user_detail_action_activate_user: 'Activar Utilizador',
  user_detail_action_archive_user: 'Arquivar Utilizador',
  user_detail_tab_overview: 'Resumo',
  user_detail_tab_member_cards: 'Cartões',
  user_detail_tab_transactions: 'Transacções',
  user_detail_tab_budgets: 'Orçamentos',
  user_detail_tab_benefits: 'Benefícios',
  user_detail_tab_reimbursements: 'Despesas',

  user_detail_toggle_status_confirm_archive_header_action:
    'Arquivar utilizador',
  user_detail_toggle_status_confirm_restore_header_action: 'Activar utilizador',

  user_detail_toggle_status_confirm_archive_warning:
    'Está prestes a arquivar o utilizador {user}, para continuar prima Arquivar Utilizador, caso contrário prima Cancelar.',
  user_detail_toggle_status_confirm_restore_warning:
    'Está prestes a activar o utilizador {user}, para continuar prima Activar Utilizador, caso contrário prima Cancelar.',
  /* - Self Onboarding  - */
  user_self_onboarding_create_account: 'Não tem uma conta? {signup}',
  user_self_onboarding_create_account_signup_here: 'Registe-se aqui',
  user_self_onboarding_register_now_label:
    'Registe-se e comece a utilizar o nosso software gratuitamente.',
  user_self_onboarding_sign_up_personal_data:
    'Introduza os seus dados pessoais',
  user_self_onboarding_sign_up_company_data:
    'Introduza os dados da sua empresa',
  user_self_onboarding_sign_up_create_security_passcode:
    'Criar um pin de segurança',
  user_self_onboarding_accept_tcs: 'Li e aceito os {tc},{sc} y {pp}',
  user_self_onboarding_tc: 'Condições de utilização',
  user_self_onboarding_sc: 'Condições dos serviços',
  user_self_onboarding_pp: 'Política de privacidade',
  user_self_onboarding_company_name: 'Nome da empresa',
  user_self_onboarding_complete_onboarding: 'Comece a usar a Fuell',
  user_self_onboarding_completed_check_email:
    'Estamos quase a terminar! Verifique o seu e-mail para activar a sua conta',
  user_self_onboarding_completed_repeat_check:
    'Se não receber o e-mail após alguns minutos, por favor clique aqui {click}',

  user_self_onboarding_cif_number: 'NÚMERO DO IVA',
  user_self_onboarding_passcode_info:
    'Por razões de segurança, precisamos que crie um {digitsbolder} com o qual possa aceder à aplicação Fuell.',
  user_self_onboarding_passcode: 'Pin de segurança',
  user_self_onboarding_passcode_placeholder: 'Pin de 4 dígitos',
  user_self_onboarding_repeat_passcode: 'Repetir pin',
  user_self_onboarding_repeat_passcode_placeholder: 'Repetir pin',

  user_self_onboarding_error: 'Ups! Tivemos um problema ao tentar registar',
  user_self_onboarding_activation_success:
    'Feito! A sua conta foi activada com sucesso',
  user_self_onboarding_activation_success_redirection:
    '{click} se o seu navegador não o redireccionar automaticamente',
  user_self_onboarding_activation_failure:
    'Tivemos um problema ao activar a sua conta',
  user_self_onboarding_activation_failure_contact_support:
    'É possível que o seu link de activação seja inválido ou já tenha sido utilizado. {customerSupport} para lhe dar uma ajuda',
  user_self_onboarding_activation_failure_message:
    'Olá, acabei de tentar activar a minha conta mas deu um erro, podem ajudar-me?',
  /* - Accept Invitation - */
  user_accept_invitation_header: 'Convite para a Fuell',
  user_accept_invitation_body:
    'Preencher as informações necessárias e enviar para impressão',
  user_invitation_form_complete_registration: 'Complete o seu registo',
  user_invitation_form_identification: 'Identificação',
  user_invitation_form_dni_expiration_date: 'Data de validade (DD/MM/YYYY)',
  user_invitation_form_id: 'Documento de identificação pessoal (CC, NIF...)',
  user_invitation_form_email_no_spam:
    'Precisamos do seu telemóvel para tornar a sua conta segura, não para lhe enviar anúncios.',
  user_invitation_form_select_expiration_date:
    'Seleccionar a data de validade do CC (cartão de cidadão)',
  user_invitation_form_create_passcode:
    'Olá {name}, crie uma senha de {digits} dígitos para a sua conta',
  user_invitation_form_create_passcode_not_card_pin:
    'Este NÃO é o seu pin de cartão.',
  user_invitation_form_create_passcode_text:
    'Pedimo-lo quando aceder ao seu cartão virtual ou quando fizer alterações à sua conta. Também não o conseguimos ver.',
  user_invitation_form_create_passcode_confirmation: 'Confirme a sua senha',
  user_invitation_form_create_passcode_confirmation_text:
    'Digite novamente a mesma senha',
  user_invitation_form_create_passcode_confirmation_not_match:
    'As senhas não coincidem, tente novamente',
  user_invitation_form_accept_terms:
    'Por favor, leia e aceite os nossos termos',
  user_terms_accept_label_new:
    'Li e aceito os novos termos ',
  user_invitation_form_token_not_found:
    'Este link de convite é inválido ou já foi utilizado. Se estiver registado, vá para a página de login onde pode iniciar sessão ou recuperar a sua palavra-passe.',
  user_accept_invitation_redirect_login: 'Leve-me para a página de login',
  user_invitation_form_token_expired:
    'Recebemos o seu convite mas, após 24 horas sem activação, expirou, por favor contacte o seu administrador para o reactivar.',
  user_invitation_form_fuell_tos_headers: 'Termos e condições gerais',
  user_invitation_form_fuell_tos_explanation:
    'Condições gerais de utilização da plataforma',
  user_invitation_form_fuell_toc_headers: 'Condições dos serviços',
  user_invitation_form_fuell_toc_explanation:
    'Condições especiais dos serviços oferecidos pela Fuell',
  user_invitation_form_fuell_privacy_policy_header:
    'Política de Privacidade da Fuell',
  user_invitation_form_fuell_privacy_policy_explanation:
    'Como mantemos os seus dados privados seguros',
  user_invitation_form_fuell_payment_provider_terms_header:
    'Condições para serviços pagos',
  user_invitation_form_fuell_payment_provider_terms_explanation:
    'Condições de prestação de serviços de pagamento',

  user_invitation_card_send_address: 'Endereço de entrega do cartão',
  user_invitation_card_send_option_send_to_office: 'Enviar para o escritório',
  user_invitation_card_send_option_send_to_other: 'Enviar para outro endereço',

  user_terms_general_conditions: 'Termos de utilização',
  user_terms_general_conditions_explanation: 'Condições de utilização da plataforma',
  user_terms_service_conditions: 'Condições de serviço',
  user_terms_service_conditions_explanation:
    'Condições dos serviços oferecidos pela Fuell',
  user_terms_privacy_policy:
    'Política de privacidade da Fuell',
  user_terms_privacy_policy_explanation:
    'Como mantemos os seus dados privados seguros',
  user_terms_payment_service_conditions:
    'Condições de serviço de pagamento',
  user_terms_payment_service_conditions_explanation:
    'Condições de prestação de serviços de pagamento',

  /* - Profile Section */
  user_profile_personal_details_tab: 'Detalhes pessoais',
  user_profile_preferences_tab: 'Preferências',
  user_profile_job_title: 'Posto',
  user_profile_email: 'Correio da empresa',
  user_profile_create_passcode: 'Criar senha',
  user_profile_change_passcode: 'Alterar senha',
  user_profile_old_passcode: 'Senha actual',
  user_profile_new_passcode: 'Nova senha',
  user_profile_change_passcode_instructions_warning:
    'Isto irá alterar a sua palavra-passe, não o PIN do seu cartão.',
  user_profile_change_passcode_step_one: 'Introduza a sua senha actual',
  user_profile_change_passcode_step_two: 'Introduza a sua nova senha',
  user_profile_change_passcode_step_three: 'Confirme a sua nova senha',
  user_profile_change_passcode_success: 'Senha actualizada',
  user_profile_change_passcode_passcode_mismatch:
    'As senhas introduzidas não correspondem',
  user_action_change_passcode_submit: 'Mudança de senha...',
  user_profile_upgrade_to_admin: 'Fazer administrador',
  user_profile_set_passcode_instructions:
    'Preencha a informação e clique em Criar Senha para a criar.',
  user_set_passcode_success: 'A senha foi criada com sucesso',
  user_profile_change_password: 'Alterar palavra-passe',
  user_profile_change_password_message: 'Introduza a nova palavra-passe de quatro dígitos para o utilizador aceder à aplicação',
  user_profile_form_forgot_passcode_action: 'Esqueceu-se da sua palavra-passe?',
  user_profile_forgot_passcode_modal_header: 'Recuperar senha ',
  user_profile_forgot_passcode_confirm_request_reset_passcode: 'Enviar e-mail',
  user_profile_forgot_passcode_message:
    'Iremos enviar-lhe um e-mail para alterar a sua palavra-passe.',
  user_profile_forgot_passcode_explain:
    'Para recuperar a sua palavra-passe escreva para {0} ou contacte-nos via chat ',
  user_set_passcode_error:
    'Ups! Algo correu mal ao tentar criar a palavra-passe para o utilizador.',
  user_update_passcode_success:
    'A senha do utilizador foi actualizada com sucesso',
  users_change_user_password_success:
    'A senha do utilizador foi actualizada com sucesso',
  user_update_passcode_error:
    'Ups! Algo correu mal ao tentar actualizar a senha do utilizador',
  user_action_fetch_user_error:
    'Ups! Algo correu mal ao tentar obter a informação do utilizador.',
  user_change_user_password_error:
    'Ups! Algo correu mal ao tentar alterar a senha do utilizador.',
  user_profile_picture_updated: 'A imagem de perfil foi actualizada',
  user_profile_picture_error:
    'Ups! Algo correu mal ao tentar mudar a sua imagem de perfil',

  user_profile_settings_ACCOUNT_LOW_BALANCE: 'Baixo saldo da empresa',
  user_profile_settings_ACCOUNT_LOW_BALANCE_comment:
    'Avisá-lo-emos antes que fique sem fundos na sua empresa.',
  user_profile_settings_ACCOUNT_BALANCE_AVAILABLE: 'Novos fundos disponíveis',
  user_profile_settings_ACCOUNT_BALANCE_AVAILABLE_comment:
    'Iremos notificá-lo quando receber novos fundos na sua empresa.',
  user_profile_settings_ACCOUNT_AVAILABLE_BALANCE_LOWER_THAN_ASSIGNED:
    'Fundos insuficientes',
  user_profile_settings_ACCOUNT_AVAILABLE_BALANCE_LOWER_THAN_ASSIGNED_comment:
    'Alertá-lo-emos quando os fundos na sua empresa forem inferiores ao saldo total disponível para os utilizadores da empresa.',
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END:
    'Encerramento das próximas transacções',
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END_comment:
    'Iremos notificá-lo 3 dias antes do fecho mensal das transacções empresariais da sua empresa.',
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END_BENEFITS: 'Fecho de contas',
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END_BENEFITS_comment:
    'Iremos notificá-lo 3 dias antes do fecho mensal das transacções da sua empresa',
  user_profile_settings_INVITED_TO_BUDGET: 'Convite para orçamento',
  user_profile_settings_INVITED_TO_BUDGET_comment:
    'Informá-lo-emos quando tiver sido convidado para um orçamento',
  user_profile_settings_ASSIGNED_AMOUNT_TO_BUDGET: 'Fundos destinados',
  user_profile_settings_ASSIGNED_AMOUNT_TO_BUDGET_comment:
    'Iremos notificá-lo quando os fundos tiverem sido atribuídos a um dos seus orçamentos.',
  user_profile_settings_WEEKLY_SUM_UP_TRANSACTION: 'Resumo semanal',
  user_profile_settings_WEEKLY_SUM_UP_TRANSACTION_comment:
    'Todas as semanas, notificá-lo-emos das transacções que tenha completado e das informações em falta para completar.',
  user_profile_settings_AUTHORIZATION_TRANSACTION: 'Autorização de compra',
  user_profile_settings_AUTHORIZATION_TRANSACTION_comment:
    'Iremos notificá-lo quando um comerciante verificar que o seu cartão é válido para compra.',
  user_profile_settings_WEEKLY_PENDING_REVIEW_TRANSACTION: 'Aviso semanal de despesas a rever',
  user_profile_settings_WEEKLY_PENDING_REVIEW_TRANSACTION_comment: 'Todas as semanas, notificá-lo-emos das despesas que tem pendentes de revisão.',

  user_profile_settings_email: 'E-mail',
  user_profile_settings_mobile: 'App',
  user_profile_settings_language: 'Idioma do website',
  user_settings_language__spanish: 'Espanhol',
  user_settings_language__english: 'Inglês',
  user_settings_language__portuguese: 'Português',

  user_post_settings_notification_success:
    'As preferências foram actualizadas correctamente',
  user_post_settings_notification_error:
    'Ups! Algo correu mal ao tentar actualizar as preferências',
  /* - SnackBars Users Messages - */
  customer_action_create_customer_success: 'Enviámos o convite ao cliente',
  customer_action_create_customer_error:
    'Ups! Algo correu mal ao convidar este cliente',
  customer_action_fetch_customers_error:
    'Ups! Algo correu mal ao solicitar a lista de clientes.',
  customer_action_update_customer_success:
    'Actualizámos com sucesso a informação do cliente',
  customer_action_update_customer_error:
    'Ups! Algo correu mal ao actualizar a informação do cliente',
  customer_action_archive_customer_success: 'Arquivámos com sucesso o cliente',
  customer_action_archive_customer_error:
    'Ups! Algo correu mal ao tentar arquivar este cliente.',
  customer_action_activate_customer_success: 'Activámos com sucesso o cliente',
  customer_action_activate_customer_error:
    'Ups! Algo correu mal ao tentar activar este cliente.',
  users_action_fetch_users_error:
    'Ups! Algo correu mal ao pedi a lista de utilizadores.',
  users_actions_update_user_success:
    'A informação do utilizador foi actualizada',
  users_actions_update_user_error:
    'Ups! Algo correu mal ao actualizar a informação do utilizador',
  users_actions_send_invitations_success:
    'Os convites foram enviados com sucesso para os utilizadores indicados.',
  users_actions_send_invitations_error:
    'Ups! Algo correu mal ao tentar enviar os convites aos utilizadores',
  users_actions_activate_user_succes: 'O utilizador foi activado com sucesso',
  users_actions_activate_user_error:
    'Ups! Algo correu mal ao tentar activar o utilizador',
  users_actions_archive_user_success: 'O utilizador foi arquivado com sucesso',
  users_actions_archive_user_error:
    'Ups! Algo correu mal ao tentar activar este utilizador.',
  users_actions_fetch_user_budgets_error:
    'Ups! Algo correu mal ao obter a lista orçamental do utilizador',

  /* User Actions Modal */
  user_action_cancel_invitation: 'Cancelar convite',
  user_actions_modal_header: 'Detalhes',
  user_actions_modal_information: 'Informações',
  user_actions_modal_settings: 'Definições',
  user_actions_modal_user_actions: 'Acções do utilizador',
  user_actions_modal_card_actions: 'Acções do cartão',
  user_actions_modal_online_payments: 'Pagamentos em linha',
  users_action_cancel_user_invitation_success:
    'Apagámos com sucesso a conta do utilizador',
  users_actions_cancel_user_invitation_error:
    'Oops! Alguma coisa correu mal ao tentar cancelar o convite do utilizador.',
  users_action_reinvite_user_success: 'O e-mail de convite foi-nos enviado correctamente.',
  users_action_reinvite_user_error: 'Oops! Algo correu mal ao reencaminhar o e-mail de convite do utilizador.',
  users_actions_confirm_modal_message:
    'Vai a {action} utilizador {user} - <{email}> , esta acção não pode ser desfeita.',
  user_action_remove_warning: 'eliminar o',
  user_action_cancel_invitation_warning: 'cancelar o convite do',
  users_confirm_cancel_invitation_header: 'Cancelar convite',
  users_confirm_remove_user_header: 'Eliminar utilizador',
  users_confirm_cancel_invitation_confirm_action: 'Eliminar',
  /* --- */

  /* --- Users Salary --- */
  user_request_gross_salary_title: 'Indica o salário do utilizador',
  user_request_gross_salary_message:
    'Para continuar, precisamos que indique o salário anual bruto do empregado.',
  user_gross_salary: 'Salário anual bruto',
  user_request_gross_salary_error_validation_message:
    'O salário mínimo para remuneração flexível deve ser {minimumSalary}.',

  /* -------- */

  /* User Finder Selector */
  user_finder_selector_type_to_find: 'Digite para pesquisar utilizadores',
  user_finder_selector_select_member: 'Adicionar Utilizador',
  user_finder_selector_no_results: 'Sem resultados, tente novamente',
  /* ------- */
  /* -------------------------------- */

  /* -- TRANSACTIONS SECTION -- */

  transactions_transactions_section_header: 'Transacções',
  transactions_transactions_subsection_charged: 'Cobradas',
  transactions_transactions_subsections_declined: 'Negadas',
  transactions_transactions_subsections_authorizations: 'Autorizações',
  transactions_transactions_subsection_pending: 'Pendentes',
  transactions_transactions_subsections_history: 'Histórico',
  transactions_actions_add_expense: 'Adicionar despesas',
  transactions_actions_create_expense: 'Despesa',
  transactions_actions_create_reimbursement: 'Despesa',
  transactions_actions_create_mileage: 'Quilómetro',
  transactions_actions_create_diet: 'Refeição',
  transactions_action_export: 'Exportação',
  transactions_action_download: 'Descarregar',
  transactions_action_close_accounting_periods: 'Fecho de contas',
  transactions_action_close_accounting_periods_title: 'Confirmar encerramento contabilístico',

  transactions_status__OK: 'Cobrada',
  transactions_status__KO: 'Negadas',
  transactions_status__PENDING: 'Pendente',
  transactions_status__REVIEWED: 'Revista',
  transactions_status__AUTHORIZATION: 'Autorização',
  transaction_status__IS_ACCOUNTED: 'Contabilizado',
  transactions_status__PROCESSING: 'Processamento',
  transactions_categorize_status__PENDING: 'Pendente',
  transactions_categorize_status__COMPLETED: 'Completado',
  transactions_categorize_status__ALL: 'Todos',
  transactions_categorize_status__INCOMPLETED: 'Falta info.',
  transactions_categorize_status__INCOMPLETED_large: 'Falta informação',
  transactions_review_flow_step_default: 'Fluxo único de aprovação',
  transactions_review_flow_step_multilevel: 'Fluxo de aprovação a vários níveis',
  transactions_payment_methods: 'Formas de pagamento',
  transactions_payment_method__WIRE_TRANSFER: 'Transferência',
  transactions_payment_method__CORPORATE_CASH: 'Dinheiro da empresa',
  transactions_payment_method__CASH: 'Dinheiro',
  transactions_payment_method__CORPORATE_CARD: 'Cartão de empresa',
  transactions_payment_method__PERSONAL_CARD: 'Cartão pessoal',
  transactions_card_type__MEMBER_PHYSICAL: 'Cartão Físico',
  transactions_card_type__MEMBER_VIRTUAL: 'Cartão virtual',
  transactions_card_type__BUDGET_VIRTUAL: 'Cartão virtual',
  transactions_dashboard_transactions_header: 'Transacções',
  transactions_dashboard_total_spent_header: 'Total gasto',
  transactions_dashboard_total_missing_info: ' Falta info.',
  transactions_dashboard_total_not_reviewed: 'Revisão em falta',
  transactions_dashboard_total_missing_info_text:
    '{missingInfoTransactionsCount} Falta de informação',
  transactions_dashboard_total_not_reviewed_text:
    ' {notReviewedTransactionsCount} Para ser revisto',
  transactions_dashboard_show_transactions: 'Mostrar transacções',
  transactions_fetch_transactions_dashboard_error:
    'Ups! Algo correu mal ao tentar obter a sua informação sobre a transacção.',
  /* - Transactions explanation labels - */

  transactions_charged_section_explanation:
    'Aqui encontrará todos os movimentos feitos pelos empregados da sua empresa com os seus cartões Fuell.',
  transactions_charged_section_expenses_explanation:
    'Aqui encontrará todos os movimentos que fez com os seus cartões Fuell.',
  transactions_authorization_section_explanation:
    'Aqui encontrará as autorizações de compra dos cartões Fuell dos funcionários da sua empresa.',
  transactions_authorization_section_expenses_explanation:
    'Aqui encontrará as autorizações de compra dos seus cartões Fuell.',
  transactions_declined_section_explanation:
    'Aqui encontrará todas as transacções negadas feitas pelos empregados da sua empresa com os seus cartões Fuell.',
  trasnactions_declined_section_expenses_explanation:
    'Aqui encontrará todas as transacções negadas que tenham sido feitas com os seus cartões Fuell.',

  transactions_table_total_count_and_amount:
    'A mostrar {totalItems} {transactionType} com um valor de {transactionTableTotalAmount}.',
  transactions_table_total_count_and_amount_user_type: 'usuario | usuarios',
  transactions_table_total_count_and_amount_transaction_type: 'transacção | transacções',
  transactions_table_total_count_and_amount_expense_type: 'despesa | despesas',

  /* - Transactions reimbursements  - */
  transactions_reimbursements_subsection_pending: 'Pendente revisão',
  transactions_reimbursements_subsection_history: 'Histórico',
  /* - Transactions reimbursements explanation labels - */
  transactions_reimbursements_history_explanation:
    'Aqui encontrará todas as despesas manuais incorridas pelos empregados da sua empresa.',
  transactions_reimbursements_userId_history_explanation: 'Aqui encontrará todas as transacções feitas por {userName}',
  transactions_reimbursements_users_history_explanation: 'Aqui encontrará todas as transacções feitas por empregados',
  transactions_reimbursements_history_expenses_explanation:
    'Aqui encontrará todas as despesas manuais que efectuou.',
  transactions_reimbursements_pending_explanation:
    'Aqui encontrará todoa as despesas manuais efectuados pelos empregados da sua empresa, pendentes de revisão.',
  transactions_reimbursements_pending_expenses_explanation:
    'Aqui encontrará todoa as despesas manuais efectuados pelos empregados da sua empresa, pendentes de revisão.',
  transactions_reimbursements_userId_pending_explanation: 'Aqui encontrará todas as transacções feitas por {userName}',
  transactions_reimbursements_users_pending_explanation: 'Aqui encontrará todas as transacções feitas por empregados',
  /* - Charged Transactions - */
  transactions_charged_table_header_status: 'Estado',
  transactions_charged_table_header_date: 'Data',
  transactions_charged_table_header_user: 'Utilizador',
  transactions_charged_table_header_processing_transactions: 'Transacções em processo',
  transactions_charged_table_header_merchant: 'Comércio',
  transactions_charged_table_header_budget: 'Orçamento',
  transactions_charged_table_header_card: 'Meios de pagamento',
  transactions_charged_table_header_card_id: 'Identificador',
  transactions_charged_table_header_amount: 'Quantidade',
  transactions_charged_table_header_receipt: 'Recibo',
  transactions_budget_not_funds_enough: 'Fundos insuficientes',
  transactions_charged_table_header_receipt_number: 'N.º de recibo',
  transactions_charged_table_header_category: 'Categoria',
  transactions_charged_table_header_subcategory: 'Subcategoria',
  transactions_charged_table_header_expense_date: 'Data da despesa',
  transactions_charged_table_header_reviewed_date: 'Data de aprovação',
  transactions_charged_table_header_provider: 'Nome da empresa',
  transactions_charged_table_header_provider_data: 'IVA',
  transactions_charged_table_header_reimbursable: 'Reembolsável',
  transactions_charged_table_header_no_reimbursable: 'Não reembolsável',
  transactions_charged_table_header_total: 'Total',

  cards_table_header_status: 'Estado',
  cards_table_header_user: 'Utilizador',
  cards_table_header_budget: 'Orçamento',
  cards_table_header_card_id: 'Identificador',
  cards_table_header_name: 'Nome',
  // RF only
  transactions_table_activity_group_category: 'Categoria',
  /* Transaction Export filters */
  transactions_export_budgets_selector_label: 'Seleccionar orçamento de exportação',
  transactions_export_cards_selector_label: 'Seleccionar cartão de exportação',
  transactions_export_reference_date: 'Data de referência',
  transactions_export_reference_date_description: 'Seleccione a data das despesas a considerar para a realização da exportação',
  transactions_export_creation_date: 'Data de criação',
  transactions_export_confirmation_date: 'Valor da data',
  transactions_export_expense_date: 'Data da despesa',
  transactions_export_approve_date: 'Data de aprovação',
  transactions_export_without_date: 'Sem data',
  transactions_export_file_format: 'Formato do ficheiro',
  transactions_export_file_format_description: 'Seleccionar o tipo de formato em que a exportação será efectuada',
  transactions_export_date_range_selector_label:
    'Intervalo de datas',
  transactions_export_date_range_selector_placeholder: 'Seleccione o intervalo de datas',
  transactions_export_info:
    'Introduza o intervalo de datas, assim como os filtros que pretende. Se introduzir um e-mail, notificá-lo-emos quando o download estiver disponível, caso contrário poderá verificar e descarregar no separador "As minhas exportações".',
  transactions_export_email_to_notify:
    'Correio para o qual o aviso deve ser enviado',
  transactions_export_action_export_and_lock:
    'Bloquear as transacções exportadas de serem modificadas.',
  transactions_export_action_export_and_lock_help:
    'Poderá desbloqueá-las, um a um, numa data posterior.',
  transactions_export_holded_config_not_present:
    'Para exportar neste formato, é necessário configurar a integração com Holded, {navigationLink} se não o tiver feito.',
  transactions_export_holded_config_click_here: 'clique aqui',
  transactions_export_default_format: 'Formato normal',
  transactions_export_default_users_format:
    'Formato normal organizado por utilizador',
  transactions_export_holded_format:
    'Formato para Holded (versão beta, em teste)',
  transactions_export_navision_format:
    'Formato para Navision (versão beta, em teste)',
  transactions_export_plexus_format: 'Formato específico para Plexus',
  transactions_export_plexus_with_tickets_format: 'Formato específico para Plexus (com recibos)',
  transactions_export_plexus_without_tickets_format: 'Formato específico para Plexus (sem recibos)',
  transactions_export_twentyfour_seven_categories_format: 'Formato de produção por categoria',
  transactions_export_talleres_garrido_format: 'Formato específico para Talleres Garrido',
  transactions_export_tecnocarrocera_format: 'Formato específico para Tecnocarrocera',
  transactions_export_wrap_file_format: 'Formato Wrap File',
  transactions_export_smile_file_format: 'Formato específico para Smile Company',
  transactions_export_rosa_gres_catalonia_ceramica_format: 'Exportar para contabilidade',

  transactions_export_custom_mapping_format: 'Ficheiro personalizado',

  transactions_export_tab_export_settings: 'Configurar a exportação',
  transactions_export_tab_download_settings: 'Configurar a descarrega',
  transactions_export_tab_export_history: 'As minhas exportações',
  transactions_export_tab_download_history: 'As minhas descarregas',
  transactions_export_modal_export_users_explanation:
    'Verá as informações exportadas discriminadas pelos utilizadores da sua empresa.',
  transactions_export_success:
    'A sua exportação está a ser processada, se o tiver indicado, enviar-lhe-emos uma notificação por correio electrónico quando estiver disponível.',
  transactions_export_error:
    'Ups! Tivemos um problema ao solicitar a exportação',
  transactions_export_request_export: 'Pedido de exportação',
  transactions_export_request_download: 'Pedido de descarrega',

  /* Transaction export history */
  transactions_export_history_table_header_export_date: 'Data de aplicação',
  transactions_export_history_table_header_export_type: 'Formato de exportação',
  transactions_export_history_table_header_export_status: 'Estado',
  transactions_export_history_table_header_export_download: 'Descarregar',
  transactions_export_history_download_in_progress: 'A gerar documento...',
  transactions_export_history_type__NORMAL: 'Normal',
  transactions_export_history_type__COMPLETE: 'Por utilizadores',
  transactions_export_history_type__HOLDED: 'Holded',
  transactions_export_history_type__NAVISION: 'Navision',
  transactions_export_history_type__BUDGETS: 'Orçamento/{budget}',
  transactions_export_history_type__PHYSICAL_CARDS: 'Cartão/{card}',
  transactions_export_history_type__VIRTUAL_CARDS: 'Cartão/{card}',
  transactions_export_history_type__EXPENSES_TRANSACTIONS:
    'Minhas despesas/Transacções',
  transactions_export_history_type__EXPENSES_REFUNDS:
    'Minhas despesas/Despesas',
  transactions_export_history_status__PENDING: 'Em espera para processamento',
  transactions_export_history_status__PROCESSING: 'Processamento...',
  transactions_export_history_status__COMPLETE: 'Pronto para descarregar',
  transactions_export_history_status__ERROR: 'Erro ao exportar',
  transactions_export_history_type__PLEXUS: 'Plexus',
  transactions_export_history_type__PLEXUS_WITHOUT_TICKETS: 'Plexus sem recibos',
  transactions_export_history_type__CUSTOM_WITHOUT_HISTORY: 'Ficheiro personalizado',
  transactions_export_history_type__CUSTOM: 'Ficheiro personalizado',
  transactions_export_history_type__CATEGORIES_BY_USER: 'Produção por categoria',

  transactions_export_history_type__WRAP_FILE: 'Formato WRAPFILE',
  transactions_export_history_type__SMILE: 'Formato SMILE',
  transactions_export_history_type__ROSA_GRES: 'Exportar para contabilidade',
  transactions_export_history_type__NORMAL_BUDGETS: 'Normal/{budget}',
  transactions_export_history_type__COMPLETE_BUDGETS: 'Por utilizadores/{budget}',
  transactions_export_history_type__HOLDED_BUDGETS: 'Holded/{budget}',
  transactions_export_history_type__NAVISION_BUDGETS: 'Navision/{budget}',
  transactions_export_history_type__BUDGETS_BUDGETS: 'Presupuesto/{budget}',

  transactions_export_history_type__CATEGORIES_BY_USER_BUDGETS: 'Produção por categorías/{budget}',
  transactions_export_history_type__WRAP_FILE_BUDGETS: 'Formato WRAPFILE/{budget}',
  transactions_export_history_type__SMILE_BUDGETS: 'Formato SMILE/{budget}',

  /* - Transactions Snackbar Messages  - */
  transactions_fetch_transactions_error:
    'Ups! Algo correu mal ao solicitar a lista de transacções.',
  transactions_fetch_transaction_error:
    'Ups! Algo correu mal ao solicitar as informações para esta transacção.',
  transactions_put_transaction_resource_error:
    'Ups! Algo correu mal ao tentar carregar o recibo para esta transacção.',
  transaction_edit_transaccion_success: 'Transacção actualizada com sucesso',
  transaction_put_transaction_error:
    'Oops! Algo correu mal ao editar a informação sobre a transacção.',
  transactions_export_transactions_error:
    'Oops! Algo correu mal ao exportar as transacções.',
  transaction_warning_AMOUNT_EXCEEDED: 'O montante destas despesas é elevado',
  transaction_warning_DUPLICATE: 'Duplicar despesa',
  transaction_warning_OUT_OF_ASSIGNED_TIME: 'Despesa fora do previsto',
  transaction_warning_WITHOUT_TICKET: 'Despesa sem recibo',
  transaction_warning_AMOUNT_DISTINCT_OCR: 'O nosso OCR leu um montante diferente no recibo do que o montante indicado na despesa.',
  transaction_warning_DISTANCE_CUSTOM_WRONG: 'Distância modificada à mão',
  transaction_warning_DISTANCE_MANUAL: 'Distância adicionada à mão porque não pôde ser calculada.',
  transaction_warning_AMOUNT_DISTINCT_SUM_TAXES: 'Os montantes indicados não coincidem com o montante total',
  transaction_warning_duplicate_text: 'Despesa {index}',
  transaction_warning_duplicate_link: 'Ir para a despesa',
  transaction_warning_duplicate_tooltip: 'Detectámos que as despesas da lista têm o mesmo recibo associado. Pode verificá-lo seguindo a ligação para cada despesa',
  transaction_warning_ignore: 'Ignorar',
  transaction_warning_ignore_modal: 'Ignorar alerta',
  transaction_warning_ignore_message: 'Tem a certeza que quer ignorar o alerta? Esta acção não pode ser desfeita',
  transaction_close_delete_draft: 'Guardar rascunho',
  transaction_close_delete: 'Eliminar despesas',
  transaction_close_without_save: 'Sair sem guardar',
  transaction_close_without_save_description: 'Tem a certeza de querer partir sem poupar as despesas?',
  /* - Edit Transaction Modal - */
  transactions_edit_original_amount: 'Quantidade original',
  transactions_edit_exchange_rate: 'Taxa de câmbio',
  transactions_edit_transaction_modal_header: 'Detalhes da transacção',
  transactions_edit_reimbursement_modal_header: 'Detalhes da despesa',
  transactions_edit_diet_modal_header: 'Detalhes de refeições',
  transactions_edit_mileage_modal_header: 'Detalhes del quilómetros',
  transactions_edit_transaction_required_fields: 'Campos Obrigatórios',
  transactions_edit_transaction_optional_fields: 'Campos opcionais',
  transactions_edit_transaction_notes_field: 'Notas',
  transactions_edit_transaction_save: 'Guardar alterações',
  transaction_edit_receipt_number: 'Nº. do recibo ou da factura',
  transactions_edit_no_resources: 'Nenhum ficheiro carregado',
  transaction_edit_receipt: 'Recibos',
  trasaction_detail_empty_receipt: 'Recibo a ser associado',
  trasaction_detail_without_receipt: 'Sem recibo',
  transaction_edit_bill_type: 'Factura ou recibo',
  transaction_edit_receipt_available: 'Recibos disponíveis',
  transactions_edit_transaction_category: 'Categoria',
  transactions_edit_transaction_subcategory: 'Subcategoria',
  transactions_edit_transaction_payment_method: 'Modo de pagamento',
  transactions_edit_transactions_custom_category: 'Subcategoria',
  transactions_edit_transaction_tax_region_selector: 'Região de tributação',
  transactions_edit_transaction_amount: 'Quantidade',
  transactions_edit_transaction_date: 'Data',
  transactions_edit_transaction_merchant: 'Comércio',
  transactions_edit_transaction_budget: 'Orçamento',
  transaction_data: 'Transaction data',
  reimbursement_data: 'Data da despesa',
  mileage_data: 'Data da quilómetros',
  diet_data: 'Data da refeições',
  transaction_tax_data: 'Dados fiscais',
  transactions_edit_receipt_number: 'Não',
  transactions_edit_company_name: 'Nome_da_empresa',
  transactions_edit_identity_number: 'número de IVA',
  transactions_edit_tax_region: 'Região fiscal',
  transactions_edit_taxes: 'Montante tributável',
  transaction_edit_address_address: 'Street',
  transaction_edit_ocr_receipt: 'OCR (Recibo {index})',
  transaction_edit_address: 'Endereço',
  transaction_edit_zip_code: 'Código postal',
  transaction_edit_city: 'Cidade',
  transaction_edit_state: 'Provincia',
  transaction_edit_country: 'País',
  transactions_edit_transaction_resources_amount:
    '{resourcesAmount} ficheiro carregado | {resourcesAmount} ficheiros carregados',
  transaction_without_receipt_modal_title: 'Não tenho recibo',
  transaction_without_receipt_modal_message: 'Pode editar a nota ou acrescentar um recibo, se necessário.',
  transaction_without_receipt_edit_note: 'Nota de edição',
  categories_action_fetch_categories_error:
    'Ups! Algo correu mal ao obter a lista de categorias',

  transactions_fetch_vat_types_error:
    'Ups! Algo correu mal ao obter a lista de regiões fiscais',
  transactions_remove_transaction_success:
    'A transacção foi removida com sucesso',
  transactions_remove_transaction_error:
    'Ups! Tivemos um problema ao eliminar a transacção',
  transactions_fetch_budget_custom_field_error:
    'Ups! Tivemos um problema ao tentar ir buscar os campos personalizados ao orçamento',
  /* - Transaction Receipt Modal and Expenses Receipts modal- */
  transactions_receipt_modal_header: 'Recibos das transacções',
  expense_modal_information_label:
    'Já pagou uma despesa empresarial com o seu dinheiro? Adicione-o aqui para que a sua empresa possa reembolsá-lo das despesas (se se enquadrar na política de despesas),',
  expenses_receipts_modal_header: 'Receitas de despesas',
  transactions_receipt_modal_body:
    'Estes são os recursos associados a esta transacção',
  expenses_receipt_modal_body:
    'Estes são os recursos que serão associados às despesas',

  transactions_receipt_modal_body_zero_results:
    'Não há recursos associados a esta transacção',
  expenses_receipt_modal_body_zero_results:
    'Não existem receitas para estas despesas',
  transactions_edit_cif_field: 'IVA',
  transactions_edit_social_reason_field: 'Nome da empresa',
  transactions_edit_tax_base: 'Base fiscal',
  transactions_edit_quota: 'Quota',
  transactions_transaction_edit_lock_transaction: 'Transacção em bloco',
  transaction_dont_have_receipt: 'Não tenho recibo',
  transactions_transaction_edit_review_transaction: 'Marcar como revisto',
  transaction_edit_transaction_lock_warning:
    'Está prestes a encerrar esta transacção, uma vez bloqueada não poderá modificá-la. Quer continuar?',
  transaction_edit_transaction_lock_warning_incomplete_transaction:
    'Esta transacção tem informação em falta e se a fechar não poderá modificá-la. Quer continuar?',
  transaction_edit_locked_transaction_label: 'Fechado em {date} por {user} ',
  transactions_processing_tooltip_label: 'Estamos a processar a informação para esta despesa e não podemos modificar a sua informação, por favor dê-nos alguns minutos e volte mais tarde.',
  transaction_review_tooltip_label: 'Revisto pelo {0} {1} em {2}',
  transaction_accounted_tooltip_label: 'Contabilizada por {0} {1} el {2}',
  transaction_lock_tooltip_label: 'Bloqueado pelo {0} {1} em {2}',
  transaction_lock_accounting_period:
    'Bloqueado devido ao encerramento contabilístico de {0}',

  transaction_dont_send_to_devoluiva:
    'Não pedir uma factura de IVA para esta despesa',
  transaction_dont_send_to_devoluiva_error:
    'Ups! Tivemos um problema ao alterar a informação sobre as transacções.',
  transaction_is_locked_error: 'Esta transacção foi bloqueada',
  transaction_upload_receipt_invalid_mimetype:
    'Formato de recibo inválido, lembre-se que pode carregar imagens e ficheiros PDF.',
  transaction_delete_transaction: 'Eliminar transacção',
  transaction_delete_expense: 'Eliminar despesas',
  transaction_delete_mileage: 'Eliminar quilómetros',
  transaction_delete_diet: 'Eliminar refeição',

  transactions_lock_transaction_success: 'Transacção bloqueada com sucesso',
  transactions_unlock_transaction_success:
    'Transacção desbloqueada com sucesso',
  transactions_review_transaction_success:
    'Transacção marcada como revista com sucesso',
  transactions_unreview_transaction_success:
    'Transacção assinalada sem revisão',
  transactions_review_selected_users_success: 'Transacções marcadas como revistas com sucesso',
  transactions_review_selected_users_error: 'Ups! Tivemos um problema ao assinalar a revisão das transacções.',

  transactions_edit_transaction_success: ' Transacção guardada com sucesso',
  transactions_lock_transaction_error:
    'Ups! Tivemos um problema ao rever o bloqueio da transacção.',
  transactions_review_transaction_error:
    'Ups! Tivemos um problema ao assinalar a revisão da transacção.',
  transaction_is_locked_message:
    'A transacção foi bloqueada e não podem ser feitas alterações.',
  transactions_choose_receipt_type: 'Seleccione se o ficheiro é um recibo ou uma factura',
  transactions_choose_receipt_type_disclaimer: 'As despesas carregadas por este método não são assinadas por Fuell e não são certificadas. Se recebeu este documento por meios digitais, não é necessário certificá-lo se o seu conteúdo não tiver sido alterado e se for proveniente de uma fonte fiável. {clickHereSlot}',
  transactions_choose_receipt_type_disclaimer_click_here: 'aqui',

  transactions_receipt_type_RECEIPT: 'Recibo',
  transactions_receipt_type_BILL: 'Factura',
  transactions_receipt_processing: 'Leitura',
  transactions_receipt_signed_date: 'Documento assinado em {signedCreatedAt}',
  transactions_receipt_type_change_RECEIPT: 'Marcar como recibo',
  transactions_receipt_type_change_BILL: 'Marcar como factura',
  transactions_receipt_type_change_question: 'Tem a certeza de que quer alterar o tipo de recibo?',
  transaction_upload_in_progress_title: 'O nosso OCR está pronto a funcionar!',
  transaction_upload_in_progress_description: 'Estamos a ler o seu recibo, pode sair da transacção em segurança. Vamos preencher os dados por si',
  transaction_upload_in_progress_understood: 'Understood',
  /* - Transactions filters */
  transactions_filter_transaction_status: 'Estado',
  transactions_filter_is_bill_all: 'Todos',
  transactions_filter_transaction_tax_type: 'IVA',
  transactions_filter_tax_types_all: 'Todos',
  transactions_filter_is_bill_only_bills: 'Facturas',
  transactions_filter_is_bill_only_receipts: 'Recibos',
  transactions_filter_transaction_accounting_period:
    'Período de encerramento contabilístico',
  transactions_filter_transaction_is_bill: 'Recibos ou facturas',
  transactions_filter_budgets_search: 'Digite para pesquisar orçamentos',
  transactions_filter_customer: 'Empresas',
  transactions_filter_customer_search: 'Pesquisa de empresas',
  transactions_filter_user_search: 'Digite para pesquisar utilizadores',
  transactions_filter_transaction_review_status: 'Revisto ou não revisto',
  transactions_review_status__ALL: 'Todos',
  transactions_review_status__REVIEWED: 'Revisto',
  transactions_review_status__NOT_REVIEWED: 'Não revisto',
  transactions_filter_transaction_personal_expense: 'Despessas pessoais',
  transactions_review_status__PERSONAL_EXPENSE: 'Despesas pessoais',
  transactions_filter_transaction_warning: 'Avisos',
  transactions_filter_transaction_account: 'Afixação',
  transactions_filter_transaction_account_ALL: 'Todos',
  transactions_filter_transaction_account_ACCOUNTED: 'Afixado em',
  transactions_filter_transaction_account_UNACCOUNTED: 'Não publicado',
  transaction_discounting: 'Descontaminar',
  transaction_account: 'Correio',
  transactions_warning__ALL: 'Todos',
  transactions_warning__WITH_WARNINGS: 'Com avisos',
  transactions_review_status__NO_WARNINGS: 'Sem avisos',
  transactions_filter_review_status: 'Estado da revisão',
  transactions_filter_review_status_placeholder: 'Filtrar por estado de revisão',
  transactions_filter_review_status_placeholder_check_selected_filters: 'Ver filtros aplicados',
  transactions_filter_review_status_flow_header_reviewed: 'Revisado',
  transactions_filter_review_status_flow_option_approved: 'Aprovado',
  transactions_filter_review_status_flow_option_personal_expense: 'Despesas de pessoal',
  transactions_filter_review_status_flow_option_rejected: 'Rejeitado',
  transactions_filter_review_status_flow_list_header_in_review: 'Em revisão',
  transactions_filter_budgets_show_archived_option: 'Mostrar arquivados',
  transactions_filter_users_show_deleted_option: 'Mostrar eliminado',
  transactions_filter_users_deleted_user: 'Borrado',

  /* ------ */
  /* - My Expenses - */
  transactions_my_expenses_reimbursements: 'Minhas despesas',
  transactions_my_expenses_transactions: 'Minhas transacções',
  /* --- */
  /* -- REVIEW FUNNEL -- */
  transactions_funnel_actions_send_for_review: 'Pedir revisão',
  transactions_funnel_update_status_transition_not_allowed:
    'Não é possível mudar para o estado de revisão.',
  transactions_change_funnel_status_success:
    'O estado da revisão foi actualizado correctamente',
  transactions_change_review_status_error:
    'Ups! Tivemos um problema ao tentar alterar o estado de revisão.',
  transactions_funnel_reject_reason_modal_title: 'Adicionar nota',
  transactions_funnel_reject_reason_modal_message:
    'Acrescentar uma nota para explicar porque é que a despesa foi rejeitada.',
  transactions_funnel_reject_reason_modal_placeholder: 'Adicionar nota',
  transactions_funnel_reject_reason_modal_validation_error: 'Deve ser redigida uma nota explicativa para rejeitar as despesas.',
  transactions_funnel_reject_reason_close_modal_title: 'Fechar janela',
  transactions_funnel_reject_reason_close_modal_warning: 'Ao fechar esta janela não se completará a acção de rejeição de despesas. Tem a certeza que quer fechar a janela?',
  transactions_funnel_reject_reason_close_modal_warning_confirm_close: 'Fechar de qualquer maneira',
  transactions_funnel_reject_reason_close_modal_warning_add_note: 'Adicionar nota',
  transactions_funnel_reject_reason_add_note_modal_title: 'Adicionar comentário',
  transactions_funnel_reject_reason_add_note_modal_message: 'Adicione o comentário que pretende que os revisores vejam a partir das seguintes etapas',
  transactions_funnel_reject_reason_add_note_close_modal_warning: 'Se fechar esta janela, a acção de {actionName} não será concluída. Tem a certeza de que quer fechar a janela?',
  transaction_funnel_comment_action_modal_action_approve: 'aprovar com comentários',
  transaction_funnel_comment_action_modal_action_mark_as_personal: 'despesas pessoais com notas',
  transaction_funnel_comment_action_modal_action_reject: 'rejeitar despesas',

  transaction_funnel_reject_reason: 'Motivo de rejeição',
  transaction_expense_rejected_label: 'Motivo de rejeição: {reviewRejectReason}',
  transactions_not_receipt_reason_modal_message: 'Acrescentar uma nota para explicar porquê é que falta o recibo',
  transactions_not_receipt_reason_modal_placeholder: 'Motivo da não-recepção',
  transactions_review_status__DRAFT: 'Rascunho',
  transactions_review_status_send_for_review: 'Em revisão',
  transactions_review_status__AWAITING_REVIEW: 'Pendente de revisão',
  transactions_review_status__APPROVED: 'Aprovado',
  transactions_review_status__CANCELLED: 'Rejeitado',
  transactions_review_status__CREATED: 'Despesa criada',
  transactions_review_status__OFFICE_FLOW_REVISION: 'Em revisão',
  transactions_review_status__NOT_VALID: 'Não validado',
  transactions_review_status__VALID: 'Validado',
  transactions_status_processing: 'Despesas retidas',
  transactions_detail_review_log_header: 'Historial',

  transactions_review_status_log_check_history: 'Ver historial',
  transactions_review_status_log_sent_for_review: 'Enviado para revisão',
  transactions_review_status_log_reviewed: 'Revisto',

  transactions_funnel_actions_review: 'Verificar',
  transactions_funnel_actions_unreview: 'Não verificar',
  transactions_funnel_actions_lock: 'Bloco',
  transactions_funnel_actions_unlock: 'Desbloquear',
  transactions_funnel_actions_account: 'Publicado em',

  transactions_funnel_actions_approve: 'Aprovar',
  transactions_funnel_actions_approve_with_comments: 'Aprovar com comentários',

  transactions_funnel_actions_approve_undo: 'Desaprovar',
  transactions_funnel_actions_reject: 'Rejeitar',
  transactions_funnel_actions_undo: 'Desfazer',
  transactions_funnel_actions_mark_as_personal: 'Despesas de pessoal',
  transactions_funnel_actions_mark_as_personal_with_comments: 'Despesas pessoais com notas',

  transactions_funnel_actions_unmark_as_personal:
    'Desmarcar as despesas pessoais',
  transactions_funnel_actions_apply_changes: 'Aplicar',
  transactions_status_personal_expense: 'Despesas de pessoal',
  transaction_taxes_error: 'Os montantes indicados não coincidem com o montante da despesa.',
  /* --- */
  /* -- Multiple transactions keys */
  transactions_review_selected_transactions_success:
    'As transacções foram assinaladas como tendo sido revistas com sucesso',
  transactions_review_selected_transactions_error:
    'Ups! Tivemos um problema na marcação de transacções como revistas.',
  transactions_unreview_selected_transactions_success:
    'As transacções foram marcadas como não tendo sido revistas correctamente.',
  transactions_unreview_selected_transactions_error:
    'Ups! Tivemos um problema na marcação de transacções como não revistas.',
  transactions_account_selected_transactions_success: 'As transacções foram assinaladas como tendo sido afixadas com sucesso',
  transactions_account_selected_transactions_error: 'Oops! Tivemos um problema ao marcarmos as transacções como postadas.',
  transactions_reject_selected_transactions_success:
    'As transacções foram marcadas como tendo sido correctamente recusadas.',
  transactions_reject_selected_transactions_error:
    'Ups! Tivemos um problema em marcar as transacções como tendo sido recusadas.',
  transactions_mark_as_review: 'Marcar como revisto',
  transactions_mark_as_review_in_progress: 'A marcar como revista...',
  transactions_mark_as_unreview_in_progress: 'Remover marcas de revisão...',
  transactions_mark_as_unreviewed: 'Remover marcas de verificação',
  transactions_total_transactions_selected:
    'Seleccionou {selectedTransactions} {transactionType}',
  transactions_total_users_selected:
    'Seleccionou as despesas de {selectedUsers} utilizador(es)',
  transactions_confirm_mark_selected_transactions_as_reviewed:
    'Marcar as transacções como revistas',
  transactions_confirm_mark_selected_transactions_as_unreviewed:
    'Marcar as transacções como não revistas',
  transactions_multiple_transactions_selected_to_review:
    'Seleccionou {transactionsAmount} transacção(ões) para marcar como revista, prima Sim para continuar ou prima Não para voltar.',
  transactions_multiple_transactions_selected_to_unreview:
    'Seleccionou {transactionsAmount} transacção(ões) para marcar como não revista, prima Sim para continuar ou prima Não para voltar.',
  transactions_multiple_transactions_action_confirm:
    'Serão feitas alterações a {transactionsTotalItems} transacções. Continuar?',
  transactions_total_transactions_bulk_selection:
    'Seleccionou a(s) {selectedTransactions} transacção(ões) carregadas de um total de {transactionsTotalItems}. ',
  transactions_total_transactions_bulk_selection_all:
    'Seleccionou todas as {transactionsTotalItems} transacções existentes. ',
  transactions_total_transactions_bulk_selection_action_select: 'Seleccione todas as {transactionsTotalItems} transacções existentes',
  transactions_total_transactions_bulk_selection_action_cancel_select:
    'Desfazer selecção',
  transactions_multiple_users_action_title: 'Aprovar despesas',
  transactions_multiple_users_action_confirm: 'Tem a certeza de que aprova estas despesas?',
  transactions_bulk_action_warning_errors:
    'A acção foi executada com alguns erros, carregámos os que falharam para si',
  transactions_bulk_action_no_context_error:
    'Há transacções bloqueadas ou num estado de revisão que não podem ser alteradas para o estado escolhido.',
  transactions_bulk_action_invalid_budget_goal_error:
    'Há despesas que excedem os limites de alguns orçamentos:',
  transactions_bulk_action_warning_confirm: 'Seleccionou {selectedTransactionsCount} despesas das quais apenas {validAmount} pode ser {bulkAction}. Quer continuar?',
  transactions_bulk_action_name__APPROVE: 'Revisão',
  transactions_bulk_action_name__REJECT: 'Rejeitar',
  transactions_bulk_action_name__LOCK: 'Bloco',
  transactions_bulk_action_name__UNLOCK: 'Desbloquear',
  transactions_bulk_action_name__UNREVIEW: 'Rejeitar',
  transactions_bulk_action_name__ACCOUNT: 'Contabilizar',

  /* --- */
  /*  Transactions --- Accounting periods */
  accounting_close_accounting_periods: 'Fechar a contabilidade',
  accounting_select_accounting_period_placeholder:
    'Seleccionar período contabilístico',
  accounting_periods_action_close_periods: 'Período de fecho',
  accounting_periods_closure_transaction_closure_warning:
    'Uma vez encerrado um período, as transacções serão bloqueadas e não poderão voltar a ser editadas.',
  accounting_periods_closure_transaction_closure_undo_warning:
    'Esta acção não pode ser desfeita.',
  accounting_period_closure_warning:
    'As transacções já não serão editáveis, quer continuar?',
  accounting_period_closure_transactions_affected:
    'Tem {amount} transacções {action} com informação em falta',
  accounting_period_action_click: '(clique para ver)',
  accounting_closure_in_progress: 'Período de encerramento...',
  accounting_periods_closure_success:
    'O período contabilístico foi encerrado correctamente',
  accounting_periods_closure_error:
    'Ups! Tivemos um problema ao encerrar o período contabilístico:',
  /* */
  /* - Transactions Misc - */
  transactions_row_file_amount: '{count} ficheiro | {count} ficheiros',
  /* -- */
  /* - Accounting - */
  accounting_action_fetch_accounting_periods_error:
    'Ups! Algo correu mal ao obter a lista dos períodos contabilísticos.',
  /* -  Expenses - */
  expenses_save_as_draft: 'Guardar como rascunho',
  expenses_send_to_review: 'Enviar a revisão',
  expenses_send_to_review_description: 'A fim de submeter as despesas para revisão, deve ser acrescentado um recibo.',
  expenses_upload_receipt: 'Recibo de carregamento',
  expenses_expense_is_reimbursable: 'Reembolsável',
  expenses_expense_is_not_reimbursable: 'Não reembolsável',
  /* - Create Expense Modal - */
  expenses_create_expense_header: 'Adicionar despesas',
  expenses_create_reimbursement_header: 'Adicionar despesa',
  expenses_edit_reimbursement_header: 'Detalhes da despesa',
  expenses_edit_expense_header: 'Detalhes das despesas',
  expense_merchant_name: 'Comércio',
  expense_payment_method: 'Modo de pagamento',
  expense_amount: 'Quantidade',
  expense_exchange_rate: 'Taxa de câmbio',
  expense_default_currency_amount: 'Montante em euros',
  expense_edit_expense_date: 'Data',
  expense_budget: 'Orçamento',
  expense_notes: 'Notas',
  expense_budget_not_enough_funds: '- Não há fundos suficientes',
  expenses_mark_as_refund: 'Regresso',

  expense_create_expense_success: 'As despesas foram acrescentadas com sucesso',
  expense_create_expense_error:
    'Ups! Tivemos um problema ao acrescentar essa despesa',
  expense_edit_expense_error:
    'Ups! Tivemos um problema com a edição desta despesa',
  /* - Create Mileage Modal - */
  expense_create_mileage_header: 'Criar despesas de quilómetros',
  expense_edit_mileage_header: 'Editar despesas de quilómetros',
  expense_mileage_origin: 'Origem',
  expense_mileage_destination: 'Destino',
  expense_mileage_category: 'Categoria',
  expense_mileage_distance_kms: 'Distância (em Kms)',
  expense_mileage_distance: 'Distância',
  expense_mileage_distance_calculated: 'Distância calculada: {kms}km',
  expense_mileage_distance_round_trip: 'Distância (ida e volta)',
  expense_mileage_amount_abbr: 'Quant.',
  expense_mileage_amount: 'Quantidade',
  expenses_create_mileage_no_categories_found_admin: 'Não existem categorias de quilómetros, {link} para as criar',
  expense_create_mileage_no_categories_found: 'Não há categorias de quilómetros, peça ao seu administrador que as crie para continuar',
  expense_create_mileage_categories_no_options: 'Nenhuma categoria criada',
  expense_create_mileage_categories_no_results: 'Não foram encontrados resultados',

  expense_create_mileage_round_trip_check: 'Viagem de ida e volta',
  expenses_create_mileage_success:
    'Os quilómetros foram adicionados correctamente',
  expense_create_mileage_error:
    'Ups! Tivemos um problema ao criar os quilómetros',
  expense_create_mileage_map_default:
    'Introduzir e seleccionar origem e destino para mostrar o mapa e calcular a distância entre os dois pontos.',
  expense_create_mileage_map_route_error_manual:
    'Houve um erro no cálculo da rota.',
  expense_create_mileage_map_route_error:
    'Houve um erro no cálculo da rota. Pode introduzir a distância manualmente.',
  /* - Create diet modal */
  expenses_create_diet_header: 'Criar refeição',
  expenses_edit_diet_header: 'Editar refeição',
  expenses_create_diet_label_origin: 'Origem',
  expenses_create_diet_label_to: 'A',
  expenses_create_diet_label_destination: 'Destino',
  expenses_create_diet_categories_to_apply:
    'Selecionar o número e o tipo de dietas',
    expense_create_diet_category_select_diet_category_placeholder: 'Adicionar dietas',

  expenses_create_diet_no_categories_found_admin:
    'Não tem categorias de refeição definidas, faça {link} para os definir',
  expenses_create_diet_no_categories_found:
    'Não existem categorias de refeição definidas, peça ao seu administrador que as crie.',
  expenses_create_diet_success: ' A refeição foi criada correctamente',
  expense_create_diet_error:
    'Ups! Tivemos um problema ao tentar criar a refeição',
  expenses_edit_diet_success: 'A refeição foi editada correctamente',
  expenses_edit_diet_error:
    'Ups! Tivemos um problema ao tentar editar a refeição',
  expense_create_diet_define_waypoints:
    'Digitar e seleccionar a origem e o destino para mostrar o itinerário.',
  expense_diet_amount_summary:
    'O montante das ajudas de custo diárias é o seguinte: {totalAmount}',
  expense_diet_add_destination: '+ Adicionar destino',
  /* ------------------------------------------------------- */
  /* -- BUDGETS TERMS -- */
  budgets_action_fetch_budgets_error:
    'Ups! Algo correu mal ao pedir a lista orçamental.',

  budgets_tabs_active_budgets: 'Activos',
  budgets_tabs_archived_budgets: 'Arquivados',
  budget_detail_expense_evolution_tab: 'Tendências das despesas',
  budget_detail_reimbursements_tab: 'Despesas',

  budgets_new_budget: 'Novo orçamento',
  budgets_add_members: 'Adicionar Utilizadores',
  budgets_budget_owner: 'Proprietário',
  budgets_budget_member: 'Membro',
  budgets_budget_cycle_selector: 'Periodicidade orçamental',
  budgets_budget_type__PUNCTUAL: 'Uma vez',
  budgets_budget_type__MONTHLY: 'Mensal',
  budgets_budget_type__DAILY: 'Diário',
  budgets_budget_type__WEEKLY: 'Semanalmente',
  budgets_budget_status__ARCHIVED: 'Arquivado',
  budgets_budget_status__ACTIVE: 'Activo',
  budgets_budget_days_to_expiration: '{daysToExpire} dias para expirar',
  budgets_budget_day_expires_today: 'Expira hoje',
  budgets_budget_days_to_expiration_expired: 'Orçamento Expirado',
  budgets_budget_goal_limit: 'Limite',
  budgets_budget_assigned: 'Atribuído',
  budgets_budget_spent: 'Gasto',
  budget_detail_header_limit: 'Limite:',
  budget_detail_header_assigned: 'Atribuído:',
  budget_detail_header_spent: 'Gasto',
  budget_confirm_archive_budget_header_action: 'Arquivar orçamento',
  budget_confirm_archive_budget_text:
    'Está prestes a arquivar o orçamento {budgetName}, esta acção não pode ser desfeita, para continuar prima Arquivar orçamento, caso contrário prima Cancelar.',
  /* -- New budgets -- */
  budgets_new_budget_header: 'Detalhes do orçamento',
  budgets_new_budget_budget_name: 'Nome Orçamento',
  budgets_new_budget_budget_limit: 'Limite',
  budgets_new_budget_type_monthly: 'Mensal',
  budgets_new_budget_type_one_time: 'Uma vez',
  budgets_budget_type__PUNCTUAL_info:
    'Estabelecer um limite e gastar até que este se esgote. O limite não é reiniciado.',
  budgets_budget_type__DAILY_info:
    'Estabelecer um limite recorrente todos os dias. O limite recomeça às 00:00 do dia seguinte.',
  budgets_budget_type__WEEKLY_info:
    'Estabelecer um limite recorrente a cada 7 dias. O limite recomeça às 00:00 no início da semana seguinte.',
  budgets_budget_type__MONTHLY_info:
    'Estabelecer um limite recorrente todos os meses. O limite é reiniciado a cada 1º dia.',
  budgets_new_budget_expiration: 'Validade',
  budgets_new_budget_owners: 'Proprietários (pelo menos um)',
  budgets_new_budget_members: 'Membros',
  budgets_new_budget_review_flow: 'Fluxo de aprovação',
  budgets_new_budget_review_flow_default_flow_info: 'Este é o fluxo de aprovação utilizado em Fuell quando não se pretende atribuir um fluxo de contribuição multinível. Consiste numa etapa de aprovação para proprietários, contabilistas e gestores de orçamentos.',
  budgets_new_budget_fuell_default_review_flow: 'Revisão simples',
  budgets_new_budget_default_review_flow: '(por defeito)',

  budget_action_create_budget_success: 'Orçamento criado com sucesso',
  budgets_action_create_budget_error:
    'Ups! Algo correu mal ao tentar criar o orçamento',
  /* ---- */
  /* - Budget Detail - */

  budget_actions_budget_settings: 'Configuração do orçamento',
  budget_actions_archive_budget: 'Arquivar Orçamento',
  /* - Budget Detail Members - */
  budget_detail_members_tab: 'Membros do orçamento',
  budget_detail_members: 'Membro',
  budget_detail_budget_assigned: 'Atribuído',
  budget_detail_budget_spent: 'Gasto',
  budget_detail_budget_available: 'Disponível em',
  budget_detail_budgter_spent_vs_available: '% Gasto vs Disponível',
  budget_user_member_owner: 'Proprietário',
  budget_detail_user_not_assigned: 'Este utilizador não está atribuído a nenhum orçamento.',
  budget_detail_assign_user: 'Atribuir um orçamento a este utilizador',
  budgets_action_update_user_assigned_budget_success:
    'A atribuição do utilizador foi actualizada correctamente',
  budgets_action_update_user_budget_success:
    'A informação do utilizador do orçamento foi actualizada correctamente.',
  budgets_action_update_user_assigned_budget_error:
    'Oops! Algo correu mal ao se tentar alterar a atribuição do utilizador.',
  budget_action_archive_budget_success:
    'O orçamento foi arquivado correctamente',
  budgets_action_archive_budget_error:
    'Ups! Alguma coisa correu mal ao tentar arquivar o orçamento.',
  budgets_update_budget_success: 'Orçamento correctamente actualizado',
  budgets_update_budget_error:
    'Ups! Algo correu mal ao tentar actualizar o orçamento',
  budgets_update_user_assign_error: 'Tem de introduzir algum montante',
  budgets_update_user_assign_greater_than_goal_error:
    'Não se pode atribuir um montante superior ao limite orçamental.',
  budgets_update_user_assign_lower_than_spent_error:
    'Não se pode atribuir um montante inferior ao que foi gasto.',

  budget_detail_budget_spent_tooltip: 'Gasto: {spent}',
  budget_detail_budget_available_tooltip: 'Disponível: {available}',
  budget_assignation_increase_alert: 'A atribuição do utilizador foi aumentada por {reimbursementSpent} com um total atribuído de {totalAssigned} numa base temporária, uma vez que aprovaram as despesas.',

  /* - Budget Detail Transactions - */
  budget_detail_transactions_tab: 'Transacções',

  /* - Budget Settings - */
  budget_month_goal_edit_warning:
    'Este é o limite orçamental para o mês em curso. As alterações não afectarão os meses futuros',

  /* --------------------------------------- */

  /* CARD FROZEN */
  card_frozen_modal_title: 'Cartão de congelação',
  card_frozen_modal_description: 'Se congelar o cartão apenas um utilizador com função de administrador poderá descongelá-lo. Tem a certeza?',
  card_frozen_modal_frozen: 'Congelar',

  /* -- CARDS TERMS -- */

  cards_budget_cards_section_tab: 'Cartões de orçamento',
  cards_physical_cards_section_tab: 'Cartões físicos',
  cards_virtual_cards_section_tab: 'Cartões virtuais',
  cards_all_cards_section_tab: 'Todas',
  card_status__DISABLED: 'Desactivado',
  card_status__ACTIVE: 'Activado',
  card_status__FROZEN: 'Congelado',
  card_status__FROZEN_tooltip: 'Congelado pelo utilizador',
  card_status__FROZEN_BY_ADMIN: 'Congelado por um administrador',
  card_status__BLOCKED: 'Bloqueado',
  card_status__PENDING: 'Pendente',
  card_status__CANCELLED: 'Cancelado',
  card_status_action_freeze_by_admin_card: 'Cartão congelado',
  card_status_action_unfreeze_card: 'Descongelar cartão',
  card_status_action_freeze_card: 'Congelar cartão',
  card_mp_identifier: 'Número MP',
  card_not_generated: 'Cartão não emitido',
  cards_budget_cards_explanation:
    'Para compras e subscrições online. Os fundos são retirados do orçamento para o qual são atribuídos.',
  cards_physical_cards_explanation:
    'Para compras na loja. Os fundos são retirados do montante atribuído ao utilizador.',
  cards_virtual_cards_explanation:
    'Para compras e subscrições online. Os fundos são retirados do montante atribuído ao utilizador.',
  cards_virtual_cards_creation_explanation:
    'Para adicionar um cartão virtual, utilize a nossa aplicação móvel.',
  cards_detail_spent: 'gasto este mês',
  cards_detail_budget: 'Orçamento',

  card_detail_modal_overview: 'Resumo',
  card_detail_modal_transactions: 'Transacções',

  card_action_request_passcode: 'Introduza a sua senha',
  card_action_input_passcode:
    'Por razões de segurança, introduza a sua senha para continuar',
  card_action_passcode_not_found: 'Senha necessária',
  card_passcode_request_instructions:
    'Por razões de segurança, precisamos que defina uma senha para gerir os seus cartões no seu perfil, de forma a continuar.',
  action_go_to_profile: 'Ir ao meu perfil',
  cards_action_new_card: 'Novo Cartão',
  cards_action_fetch_cards_error:
    'Ups! Algo correu mal ao tentar obter a lista de cartões.',
  cards_action_activate_card_success: 'Cartão activado com sucesso',
  cards_action_freeze_card_success: 'Cartão congelado correctamente',
  cards_action_activate_card_error: 'Ups! Algo correu mal ao activar o cartão',
  cards_action_freeze_card_error:
    'Ups! Algo correu mal ao congelar o cartão',
  /* --- Logs Section ---- */
  logs_office_log_tab: 'Registos da empresa',
  logs_user_log_tab: 'Registos de Utilizador',
  logs_cards_log_tab: 'Registos de cartões',
  logs_webhook_log_tab: 'Registos do WebHook',
  fetch_log_error: 'Tivemos um problema ao tentar obter os registos: ',
  /* ------------------ */

  /* - COMPANY TERMS  --- */
  company_settings_company_details_tab: 'Detalhes da empresa',
  company_settings_transaction_fields_tab: 'Ajustes de custos',
  company_settings_expense_fields_tab: 'Quilómetros e refeições',
  company_settings_integrations: 'Integrações',
  company_settings_export: 'Definição de exportação de dados',

  /* - Company Details - */
  company_details_company_name: 'Nome da empresa',
  company_details_company_address: 'Endereço da empresa',
  company_details_company_zip_code: 'Código postal',
  company_details_company_city: 'Cidade',
  company_details_company_country_state: 'País / Província',
  company_details_company_registration_number: 'Número de registo',
  company_details_company_change_information_message:
    'Deseja alterar ou actualizar algo? {0}',
  company_support_update_company_information_message:
    'Olá, gostaria de mudar a informação da minha empresa, o que tenho de fazer?',
  company_details_transaction_fields_subtitle:
    'Editar e criar os diferentes campos que são exibidos nas despesas e transacções.',
  company_details_default_fields_title: 'Definições de campos e alertas',

  company_details_receipt_settings: 'Ajustes de recibos',
  company_details_receipt_settings_description:
    'Configurar as definições de recibos',
  company_details_categories_and_subcategories: 'Categorias e subcategorias',
  company_details_categories_and_subcategories_description:
    'Criar categorias e subcategorias personalizadas',

  company_details_fields_settings_required_fields: 'Campos obrigatórios',
  company_details_fields_settings_required_fields_description: 'Definir os campos obrigatórios para as despesas',

  company_details_fields_settings_alerts: 'Alertas',
  company_details_fields_settings_alerts_description: 'Criar alertas para despesas em duplicado ou fora de horas.',

  company_details_fields_settings_payment_methods: 'Formas de pagamento',
  company_details_fields_settings_payment_methods_description: 'Definir as formas de pagamento aceites pela sua empresa',
  company_details_fields_settings_cards_schedule: 'Horas de utilização dos cartões Fuell',
  company_details_fields_settings_company_details_fields_settings_cards_schedule_description: 'Define as horas em que os pagamentos podem ser efectuados com o cartão Fuell',
  company_details_add_fields: 'Campos personalizados',
  company_details_new_field_button: 'Adicionar campo',
  company_details_new_category_button: 'Adicionar categoría',
  company_details_new_subcategory_button: 'Adicionar subcategoria',
  company_details_remove_subcategory_action: 'Eliminar subcategoría',

  company_details_action_create_custom_category_success:
    'A subcategoria foi criada com sucesso',
  company_details_action_create_custom_category_error:
    'Ocorreu um erro ao criar a subcategoria',
  company_details_action_update_custom_category_success:
    'A subcategoria foi actualizada com sucesso',
  company_details_action_update_custom_category_error:
    'Ocorreu um erro ao actualizar a subcategoria',
  company_details_action_delete_custom_category_success:
    'A subcategoria foi removida com sucesso',
  company_details_action_delete_custom_category_error:
    'Ocorreu um erro ao actualizar a subcategoria',
  company_details_action_update_default_category_success:
    'A categoria foi actualizada com sucesso',
  company_details_action_update_default_category_error:
    'Ocorreu um erro ao actualizar a categoria',
  company_details_category_field: 'Categoria',
  company_details_subcategory_name_field: 'Nome',
  company_details_account_number_field: 'Código',
  company_details_tax_field: 'IVA',
  company_details_confirm_modal_delete_subcategory:
    'Vai eliminar a subcategoria {name}. Esta acção não pode ser desfeita.',

  company_details_create_category_category_name: 'Nome da categoria',
  company_details_create_category_category_color: 'Cor',

  company_details_create_category_create_category_action: 'Criar categoria',
  company_details_new_category_title: 'Criar categoria',
  company_details_edit_category_title: 'Editar categoria',
  company_details_edit_category_action: 'Guardar alterações',
  company_details_delete_category_title: 'Eliminar categoria',
  company_details_dete_category_info: 'Tem a certeza de que pretende eliminar a categoria? Todas as subcategorias associadas serão também eliminadas. Esta acção não pode ser anulada',
  company_details_new_category_action_success: 'A categoria foi criada com sucesso',
  company_details_new_category_action_error: 'Ops! Algo correu mal ao criar a categoria',

  company_details_admin_notifications_header: 'Notificações da administração',
  company_details_admin_notifications_copy:
    'Indicar os endereços de e-mail para os quais pretende que sejam enviados e-mails quando a conta estiver a funcionar mal, o saldo disponível for inferior aos fundos atribuídos ou quando a conta for reforçada com mais de 1.000 euros.',
  company_details_notification_mails_list: 'E-mail a serem notificados',
  company_details_notification_mails_placeholder:
    'Digite para adicionar ou seleccionar um e-mail...',
  company_details_notification_mails_add_tag_placeholder: 'Adicionar e-mail',
  company_details_notification_mails_selected_label:
    'Uma vez na lista, clique para apagar',
  company_details_notification_mails_invalid_mail:
    'Introduzir um endereço de correio electrónico válido',
  company_details_notification_mail_submit_error:
    'Ups! Algo correu mal ao tentar actualizar a lista de e-mails a serem notificados',
  company_details_company_time_zone: 'Fuso horário',
  /* - Company Fields  */
  company_transaction_fields_table_transaction_field_name_header:
    'Campo de transacção',
  company_transaction_fields_table_field_options_header: 'Opções de campo',
  company_transaction_fields_table_budgets_header: 'Orçamentos',
  company_transaction_fields_table_include_in_transaction_type_header:
    'Incluído em',
  /* Mandatory Fields Modal */
  company_required_fields_modal_header: 'Campos obrigatorios',
  company_required_fields_modal_info: 'Define os campos que são de preenchimento obrigatório para os empregados.',

  company_required_fields_modal_form__MILEAGE: 'Quilómetros',
  company_required_fields_modal_form__DIET: 'Refeições',
  company_required_fields_modal_form__REIMBURSEMENT: 'Despesas',
  company_required_fields_modal_form__EXPENSE: 'Despesas',
  company_required_fields_modal_form__TRANSACTION: 'Transacçãoes',
  company_required_fields_modal_form_field__paymentMethod: 'Formas de pagamento',
  company_required_fields_modal_form_field__dietSteps: 'Origem e destino',
  company_required_fields_modal_form_field__dietCategoryConfigs: 'Categoria de refeição',
  company_required_fields_modal_form_field__medias: 'Recibos',
  company_required_fields_modal_form_field__budget: 'Orçamento',
  company_required_fields_modal_form_field__notes: 'Notas',
  company_required_fields_modal_form_field__amount: 'Quantidade',
  company_required_fields_modal_form_field__mileageCategory: 'Categoria de quilómetros',
  company_required_fields_modal_form_field__origin: 'Origem',
  company_required_fields_modal_form_field__destination: 'Destino',
  company_required_fields_modal_form_field__distance: 'Distância',
  company_required_fields_modal_form_field__roundTrip: 'Viagem de ida e volta',
  company_required_fields_modal_form_field__date: 'Data',
  company_required_fields_modal_form_field__isBill: 'Factura o recibo',
  company_required_fields_modal_form_field__provider: 'Comércio',
  company_required_fields_modal_form_field__transaction_provider: 'Nome da empresa',
  company_required_fields_modal_form_field__defaultCategory: 'Categoria',
  company_required_fields_modal_form_field__providerData: 'CIF',
  company_required_fields_modal_form_field__receiptNumber: 'N.º de recib',
  company_required_fields_modal_form_field__vatTypeAssigned: 'Região de tributação',
  company_required_fields_modal_form_field__country: 'País',
  company_required_fields_modal_form_field__state: 'Provincia',
  company_required_fields_modal_form_field__zipCode: 'Código postal',
  company_required_fields_modal_form_field__city: 'Cidade',
  company_required_fields_modal_form_field__address: 'Endereço',
  company_required_fields_modal_form_field__taxes: 'Montante tributável',

  company_required_fields_modal_option_field_name: 'Nome do campo',
  company_required_fields_modal_option_field_required_status: 'Obrigatorio',

  company_required_fields_modal_update_setting_success: 'Foi actualizado correctamente',
  company_required_fields_modal_update_setting_error: 'Oops! Alguma coisa correu mal ao tentar actualizar a configuração solicitada.',

  /* Create Custom Field Modal */
  company_create_transaction_field_modal_header: 'Criar novo campo',
  company_update_transaction_field_modal_header: 'Actualização de campo',
  company_update_transactions_transactions_affected_warning:
    'Tem transacções com informação relacionada com este campo, quer continuar?',
  company_create_transaction_field_name: 'Nome',
  company_create_transaction_field_name_placeholder:
    'Introduza o nome do campo',
  company_create_transaction_field_description: 'Descrição',
  company_create_transaction_field_description_placeholder:
    'Introduzir descrição para o campo',
  company_create_transaction_field_option_type:
    'Permite-lhe seleccionar mais do que uma opção',
  company_create_transaction_field_allow_multiselect:
    'Permitir a selecção de vários',
  company_create_transaction_field_option_settings:
    'Criar as opções para este campo',
  company_create_transaction_field_option_settings_placeholder:
    'Digite e pressione enter',
  company_create_transaction_field_option_tag_transaction_detail_placeholder:
    'Criar esta opção',

  company_create_transaction_field_allow_custom_options:
    'Permitir que o empregado crie outros',
  company_create_transaction_field_allow_custom_options_info:
    'Permite que o empregado crie novas opções',
  company_create_transaction_field_budgets_include_in: 'Incluir este campo em',
  company_create_transaction_field_include_in_all_budgets:
    'Todos os orçamentos',
  company_create_transaction_field_include_in_all_budgets_explanation:
    'Incluir em todos os orçamentos actuais e futuros',
  company_create_transaction_field_include_in_selected_budgets:
    'Orçamentos seleccionados',
  company_create_transaction_field_require: 'Exigir este campo em',
  company_create_transaction_field_require_never: 'Nunca',
  company_create_transaction_field_require_always: 'Sempre',
  company_create_transaction_field_require_selected_budgets:
    'Para orçamentos seleccionados',
  company_create_transaction_field_action_create_field: 'Criar campo',
  company_create_transaction_field_action_update_field: 'Campo de actualização',
  company_create_transaction_field_options_no_options:
    'Digite e pressione enter',
  company_create_transaction_field_select_budget: 'Seleccionar orçamento',
  company_create_transaction_field_no_budgets: 'Sem orçamentos',

  company_create_custom_field_success: 'O campo foi criado correctamente',
  company_update_custom_field_success: 'O campo foi actualizado correctamente',
  company_delete_custom_field_success: 'O campo foi eliminado correctamente',

  company_create_custom_field_error: 'Ocorreu um erro ao criar o campo',
  company_update_custom_field_error: 'Ocorreu um erro ao actualizar o campo',
  company_delete_custom_field_error: 'Ocorreu um erro ao apagar o campo',
  company_fetch_transaction_fields_error:
    'Ocorreu um erro ao carregar os campos',
  company_fetch_company_error: 'Ocorreu um erro nos dados da empresa',
  company_update_company_information_error: 'Oops! Alguma coisa correu mal ao actualizar a informação da empresa.',

  company_update_company_information_success:
    'A informação foi actualizada correctamente',

  company_create_custom_field_include_in_transaction_type:
    'Incluir este campo em',
  company_update_company_address_info: 'Está prestes a editar o endereço de envio do cartão da empresa {customerName}, preencha todos os campos solicitados e prima Enviar',
  company_update_company_address_warning: 'Está prestes a editar o endereço de envio do cartão da empresa {customerName}, certifique-se de que verifica se os dados estão correctos e prima Confirmar para guardar as alterações, caso contrário prima Cancelar para devolver.',
  company_update_company_fiscal_address_info: 'Está prestes a editar o endereço de facturação da empresa {customerName}, preencha todos os campos solicitados e prima Enviar',
  company_update_company_fiscal_address_warning: 'Está prestes a editar o endereço de facturação da empresa {customerName}, certifique-se de que verifica se os dados estão correctos e prima Confirmar para guardar as alterações, caso contrário prima Cancelar para devolver',
  customer_edit_address_modal_header: 'Editar o endereço de envio do cartão de empresa',
  customer_edit_address_confirm: 'Editar endereço',
  customer_edit_fiscal_address_modal_header: 'Editar morada de facturação da empresa',
  customer_show_edit_fiscal_address_modal_action: 'Endereço de facturação da empresa',
  customer_show_edit_address_modal_action: 'Endereço para envio de cartões',

  /* - Payment Methods modal - */
  company_payment_methods_settings_modal_title: 'Formas de pagamento',
  company_payment_methods_settings_description: 'Pode configurar os métodos de pagamento que a sua empresa suporta, para além do cartão Fuell. É possível definir os tipos de despesas para as quais podem ser utilizados, os empregados que têm o método activo e se permitem o reembolso.',
  company_payment_methods_table_payment_method_header: 'Forma de pagamento',
  company_payment_methods_table_expense_type_header: 'Tipo de despesas',
  company_payment_methods_table_users_header: 'Utilizadores',
  company_payment_methods_table_repayable_header: 'Reembolsável',
  company_payment_methods_table_bydefault_header: 'Predefinição',
  company_payment_methods_table_repayable_tooltip: 'As despesas marcadas com esta opção aparecerão como reembolsáveis no ficheiro de exportação',
  empresa_payment_methods_table_byDefault_tooltip: 'Os métodos de pagamento que seleccionar serão atribuídos a novos utilizadores por defeito',
  método_de_pagamento_da_empresa: 'Se o método de pagamento for aplicado a Todos, será atribuído por defeito a novos utilizadores',
  company_payment_methods_table_payment_method_name_placeholder: 'Nombe',
  company_payment_methods_table_expense_type_placeholder: 'Tipo de despesas',
  company_payment_methods_table_users_placeholder: 'Utilizadores',
  company_payment_methods_add_payment_method_action: '+ Adicionar método de pagamento',
  company_payment_methods_modal_confirm_delete: 'Eliminar método de pagamento',
  company_payment_methods_modal_confirm_delete_warning: 'Tem a certeza de que pretende eliminar o método de pagamento? Esta acção não pode ser desfeita',
  company_payment_methods_modal_update_error: 'Oops! Alguma coisa correu mal ao tentar actualizar o método de pagamento.',
  company_payment_methods_modal_create_error: 'Oops! Algo correu mal quando se tentou criar o método de pagamento.',
  company_payment_methods_modal_delete_error: 'Oops! Algo correu mal ao tentar apagar o método de pagamento.',
  company_payment_methods_modal_get_payment_methods_error: 'Oops! Algo correu mal ao tentar obter os métodos de pagamento.',

  /* - Card Schedule Modal - */
  company_cards_schedule_settings_modal_title: 'Definir horários de utilização do cartão',
  company_cards_schedule_settings_description: 'Pode estabelecer um calendário para a utilização dos cartões de acordo com o orçamento que lhes foi atribuído. Se um orçamento não tiver um horário atribuído, os cartões poderão passar qualquer dia a qualquer hora.',
  company_cards_schedule_table_name_header: 'Nome',
  company_cards_schedule_table_days_header: 'Dias',
  company_cards_schedule_table_hours_header: 'Horas',
  company_cards_schedule_table_budgets_header: 'Orçamentos',
  company_cards_schedule_table_card_schedule_name_placeholder: 'Nome',
  company_cards_schedule_table_budgets_placeholder: 'Orçamentos',
  company_cards_schedule_add_card_schedule_action: '+ Adicionar calendário',
  company_cards_schedule_settings_default_title: 'Calendário por defeito para novos orçamentos',
  company_cards_schedule_settings_default_description: 'Pode escolher um calendário a ser aplicado automaticamente aos novos orçamentos criados na empresa.',
  company_cards_schedule_settings_default_label: 'Horário por defeito',
  company_cards_schedule_modal_overwrite_budget: 'Alteração do horário atribuído',
  company_cards_schedule_modal_overwrite_budget_single: 'O orçamento que seleccionou tem outro calendário que lhe é atribuído. Quer atribuir-lhe este novo calendário?',
  company_cards_schedule_modal_overwrite_budget_multiple: 'Vários orçamentos que seleccionou têm outro calendário atribuído a eles. Quer atribuir-lhes este novo calendário?',
  company_cards_schedule_modal_confirm_delete: 'Apagar o horário do cartão',
  company_cards_schedule_modal_confirm_delete_warning: 'Tem a certeza de que pretende apagar o horário? Esta acção não pode ser anulada',

  /* - Expenses Fields  - */

  expense_fields_creation_subtitle:
    'Nesta secção pode configurar aspectos específicos da criação de despesas, tais como categorias de quilómetros.',
  expense_fields_mileage_categories: 'Categorias de quilómetros',
  expense_fields_diet_categories: 'Categorias de refeições',
  company_expense_fields_mileage_category_header: 'Nome',
  company_expense_fields_mileage_category_rate: 'Custo por quilómetro',

  expense_fields_new_mileage_category: 'Adicionar categoria de quilómetros',
  expense_fetch_mileage_categories_error:
    'Adicionar categoria de quilómetros',
  company_update_mileage_category_success:
    'A categoria de quilómetros foi actualizada correctamente',
  company_update_mileage_category_error:
    'Ups! Algo correu mal ao tentar actualizar a categoria de quilómetros.',
  company_create_mileage_category_success:
    'A categoria de quilómetros foi criada correctamente',
  company_create_mileage_category_error:
    'Ups! Algo correu mal ao tentar criar a categoria de quilómetros.',
  company_delete_mileage_category_success:
    'A categoria de quilómetros foi removida correctamente.',
  company_delete_mileage_category_error:
    'Ups! Algo correu mal ao tentar criar a categoria de quilómetros.',
  /* - Create mileage and diet categories  modal - */
  company_create_mileage_category_modal_header:
    'Criar categoria de quilómetros',
  company_edit_mileage_category_modal_header:
    'Categoria de edição de quilómetros',
  company_create_mileage_category_modal_confirm: 'Criar categoria',
  company_edit_mileage_category_modal_confirm: 'Guardar alterações',
  company_edit_diet_category_modal_header: 'Editar categoria de refeição',
  company_create_diet_category_modal_header: 'Criar categoria de refeição',
  company_edit_diet_category_modal_confirm: 'Guardar alterações',
  company_create_diet_category_modal_confirm: 'Criar categoria',
  expense_fields_new_diet_category: 'Criar categoria de refeição',

  company_update_diet_category_success:
    'A categoria de refeição foi actualizada correctamente',
  company_update_diet_category_error:
    'Ups! Algo correu mal ao tentar actualizar a categoria de refeição.',
  company_create_diet_category_success:
    'A categoria de refeição foi criada correctamente',
  company_create_diet_category_error:
    'Ups! Algo correu mal ao tentar criar a categoria de refeição.',
  company_delete_diet_category_success:
    'A categoria de refeição foi eliminada correctamente',
  company_delete_diet_category_error:
    'Ups! Algo correu mal quando se tentou eliminar a categoria de refeição.',
  expense_fetch_diet_categories_error:
    'Ups! Algo correu mal ao tentar obter a lista de categorias de refeiçãp.',

  company_create_mileage_category_name: 'Nome',
  company_create_mileage_category_rate: 'Custo por km (€/Km)',
  company_create_diet_category_amount: 'Quantidade',

  /* - Funnel Aproval options */

  company_funnel_aproval_flow_section_header: 'Fluxos de aprovação',
  company_funnel_aproval_flow_create_flow: 'Criar fluxo de aprovação',
  company_funnel_aproval_flow_info: 'Criar e editar fluxos de aprovação com múltiplos níveis de revisão. Orçamentos sem fluxo de vários níveis atribuídos funcionarão com aprovação simples por defeito.',

  company_funnel_aproval_flow_table_column_name: 'Nome',
  company_funnel_aproval_flow_table_column_aproval_levels: 'Níveis de aprovação',
  company_funnel_aproval_flow_table_column_budgets: 'Orçamentos',

  /* Create funnel flow modal */
  company_create_funnel_flow_modal_header: 'Criar fluxo de aprovação multinível',
  company_edit_funnel_flow_modal_header: 'Editar fluxo de aprovação multinível',
  company_create_funnel_flow_modal_form_name: 'Nome',
  company_create_funnel_flow_modal_form_name_placeholder: 'Nome do fluxo de aprovação',
  company_create_funnel_flow_modal_form_include_flow_in: 'Incluir o fluxo de aprovação em',
  company_create_funnel_flow_modal_form_include_flow_in_all_budgets_option: 'Todos os orçamentos  {all_budgets_hint}',
  company_create_funnel_flow_modal_form_include_flow_in_all_budgets_option_hint: '(A ser incluído em todos os orçamentos actuais e futuros.)',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option: 'Orçamentos seleccionados',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_name: 'Orçamentos',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_name_placeholder: 'Buscar...',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_all_budgets_option: 'Todos',
  company_create_funnel_flow_modal_form_mark_as_default_label: 'Utilizar como fluxo de aprovação por defeito',
  company_create_funnel_flow_modal_form_mark_as_default_info_tooltip: 'Este fluxo de aprovação é atribuído por defeito aos novos orçamentos criados na plataforma.',

  company_create_funnel_flow_modal_form_confirm_budget_change_header: 'Reatribuir o fluxo de aprovação',
  company_create_funnel_flow_modal_form_confirm_budget_change_warning: 'Este orçamento tem outro fluxo de aprovação que lhe foi atribuído. Tem a certeza de que o quer reafectar?',
  company_create_funnel_flow_modal_form_confirm_budget_change_action_confirm: 'Reafectar',
  company_create_funnel_flow_modal_form_confirm_default_flow_change_header: 'Fluxo de aprovação por defeito',
  company_create_funnel_flow_modal_form_confirm_default_flow_warning: 'Existe outro fluxo de aprovação definido por defeito, tem a certeza que quer seleccionar este como o fluxo por defeito?',

  company_create_funnel_flow_modal_form_flow_steps: 'Etapas do fluxo',
  company_create_funnel_flow_modal_form_flow_steps_hint: 'Indica as etapas pelas quais uma despesa deve passar no fluxo de aprovação, bem como os papéis/pessoas que irão rever a despesa em cada etapa.',
  company_create_funnel_flow_modal_form_flow_steps_add_step: '+ Adicionar etapa',
  company_create_funnel_flow_modal_form_flow_steps_add_step_name: 'Nome',
  company_create_funnel_flow_modal_form_flow_steps_add_step_name_placeholder: 'Nome da etapa',
  company_create_funnel_flow_modal_form_flow_steps_add_step_reviewers: 'Revisore(es)',
  company_create_funnel_flow_modal_form_flow_steps_add_step_reviewers_placeholder: 'Pesquisar...',

  company_create_funnel_flow_modal_form_create_flow: 'Criar fluxo de revisão',
  company_create_funnel_flow_modal_form_edit_flow: 'Guardar alterações',

  company_fetch_review_flows_error: 'Oops! Tivemos um problema ao tentar obter a lista dos fluxos de revisão.',

  company_fetch_review_flow_error: 'Oops! Tivemos um problema ao tentar obter este fluxo de revisão.',
  company_create_review_flow_success: 'O fluxo de revisão foi criado correctamente',
  company_update_review_flow_success: 'O fluxo de revisão foi actualizado correctamente',
  company_create_review_flow_error: 'Oops! Tivemos um problema ao tentar criar este fluxo de revisão.',
  company_update_review_flow_error: 'Oops! Tivemos um problema ao tentar actualizar este fluxo de revisão.',
  company_delete_review_flow_success: 'O fluxo de revisão foi eliminado com sucesso',
  company_delete_review_flow_error: 'Oops! Algo correu mal ao tentar apagar este fluxo de revisão',

  /* Integrations */
  company_integrations_settings_information:
    'Encontrará aqui as configurações necessárias para nos integrar com as suas plataformas ERP externas. Se não encontrar a sua plataforma, pode recomendar integrações na secção de sugestões da lista.',
  company_integrations_suggest_integration: 'Sugestões?',
  company_integrations_suggest_integration_comment:
    'Recomendar uma integração!',
  company_intragrations_settings_config_updated_success:
    'A configuração foi actualizada correctamente',

  /* -- Integrations: Holded */
  company_integrations_settings_holded_payment_account_number:
    'Número da conta de pagamento',
  /* ------------------- */
  company_export_settings_information: 'Nesta secção pode configurar tudo o que necessita para exportar informações sobre transacções e despesas para o seu software de contabilidade.',
  company_export_settings_field_mapping_name: 'Nome',
  company_export_settings_field_mapping_author: 'Autor',
  company_export_settings_field_mapping_used: 'Usado em',
  company_export_settings_file_format_name: 'Nome',
  company_export_settings_file_format_author: 'Autor',
  company_export_settings_file_format_format: 'Formato',
  company_export_settings_file_format_used: 'Usado em',
  company_export_settings_file_formats: 'Formato de ficheiros de exportação',
  company_export_settings_new_format: 'Criar um novo formato',
  company_export_settings_field_mapping: 'Cartografia de campo',
  company_export_settings_new_mapping: 'Criar novo mapeamento',
  company_export_settings_create_field_mapping_name: 'Nome',
  company_export_settings_create_field_mapping_correspondence: 'Correspondência entre impostos',
  company_export_settings_create_field_mapping_correspondence_subtitle: 'Aqui pode modificar os valores que serão utilizados para especificar impostos sobre a exportação. Lembre-se! Se não o modificar, o valor da Fuell será exportado.',
  company_export_settings_create_field_mapping_region: 'Região',
  company_export_settings_create_field_mapping_fuell: 'Em combustível',
  company_export_settings_create_field_mapping_export: 'A exportar',
  company_export_settings_create_field_mapping_category: 'Categoria',
  company_export_settings_edit_field_mapping_modal_header: 'Editar cartografia',
  company_export_settings_create_field_mapping_modal_header: 'Nova cartografia',
  company_export_settings_edit_field_mapping_modal_confirm: 'Guardar',
  company_export_settings_create_field_mapping_modal_confirm: 'Guardar',
  company_export_settings_create_file_format_format: 'Formato do ficheiro',
  company_export_settings_create_file_format_csv: 'CSV (Valores Separados por Vírgulas)',
  company_export_settings_create_file_format_xlsx: 'XLSX (Excel)',
  export_exportation_flow_include_tickets: 'Incluir recibos',
  company_export_settings_create_file_format_columns: 'Colunas de arquivo',
  company_export_settings_create_file_format_columns_subtitle: 'Indique as colunas que deseja que o ficheiro final tenha, indicando os dados que precisa de ter em cada uma delas.',
  company_export_settings_create_file_format_name: 'Nome',
  company_export_settings_create_file_format_data: 'Dados',
  company_export_settings_create_file_format_tag: 'Digite e pressione enter',
  company_export_settings_create_file_format_example: 'Exemplo',
  company_export_settings_create_file_format_add_column: '+ Adicionar coluna',
  company_export_settings_edit_file_format_modal_header: 'Formato de edição',
  company_export_settings_create_file_format_modal_header: 'Novo formato',
  company_export_settings_edit_file_format_modal_confirm: 'Guardar',
  company_export_settings_create_file_format_modal_confirm: 'Guardar',

  export_fetch_export_fields_error: 'Ups! Algo correu mal quando se tentou ir buscar o mapeamento de campos',
  export_fetch_file_format_error: 'Ups! Algo correu mal ao tentar ir buscar o formato do ficheiro',
  export_fetch_file_formats_error: 'Ups! Algo correu mal ao tentar ir buscar os formatos dos ficheiros',
  export_update_file_format_error: 'Ups! Algo correu mal ao actualizar o formato do ficheiro',
  export_create_file_format_error: 'Ups! Algo correu mal ao criar o formato de ficheiro',
  export_delete_file_format_error: 'Ups! Algo correu mal ao apagar o formato do ficheiro',
  expense_fetch_fields_mapping_error: 'Ups! Algo correu mal ao tentar ir buscar cartografias de campo',
  expense_update_fields_mapping_error: 'Ups! Algo correu mal ao actualizar o mapeamento de campos',
  expense_create_fields_mapping_error: 'Ups! Algo correu mal ao criar o mapeamento de campos',
  expense_delete_fields_mapping_error: 'Ups! Algo correu mal ao apagar o mapeamento de campos',
  export_update_file_format_success: 'O formato do ficheiro foi actualizado com sucesso',
  export_create_file_format_success: 'O formato do ficheiro foi criado com sucesso',
  export_delete_file_format_success: 'O formato do ficheiro foi eliminado com sucesso',
  expense_update_fields_mapping_success: 'O mapeamento de campo foi actualizado com sucesso',
  expense_create_fields_mapping_success: 'O mapeamento de campo foi actualizado com sucesso',
  expense_delete_fields_mapping_success: 'O mapeamento de campo foi criado com sucesso',
  export_fetch_exportation_flows_error: 'O mapeamento de campo foi eliminado com sucesso',
  export_fetch_exportation_flow_error: 'Ups! Algo correu mal quando se tentou ir buscar o fluxo de exportação',
  export_update_exportation_flow_error: 'Ups! Algo correu mal ao actualizar o fluxo de exportação',
  export_create_exportation_flow_error: 'Ups! Algo correu mal ao criar o fluxo de exportação',
  export_delete_exportation_flow_error: 'Ups! Algo correu mal ao eliminar o fluxo de exportação',
  export_create_export_history_error: 'Ups! Algo correu mal ao criar a exportação',
  export_update_exportation_flow_success: 'O fluxo de exportação foi actualizado com sucesso',
  export_create_exportation_flow_success: 'O fluxo de exportação foi criado com sucesso',
  export_delete_exportation_flow_success: 'O fluxo de exportação foi eliminado com sucesso',
  export_create_export_history_success: 'A exportação foi criada com sucesso',
  export_count_used_more: ' e + { quantity } mais',
  /* ------------------- */

  /* Benefits - Flexible Remuneration section */
  benefits_users_table_header_employee: 'Nome',
  benefits_users_table_header_meals_activated: 'Refeições activadas',
  benefit_users_table_header_limit: 'Limite refeições',
  benefits_users_table_header_limit_meal_accumulative: 'Saldo alimentos',
  benefit_users_table_header_limit_monthly_assigned: 'Subsídio mensal',
  benefits_users_table_header_spent_vs_available: '% Gasto vs. disponível',
  benefits_users_table_header_transport_activated: 'Transporte activado',
  benefit_users_table_header_transport_limit: 'Limite de transporte',
  benefits_users_table_header_limit_transport_accumulative:
    'Saldo transportes',
  benefits_users_table_header_nursery_assignation:
    'Cuidados infantis: atribuição',
  benefits_tab_flex_retribution: 'Plano de remuneração flexível',
  benefits_tab_social_benefits: 'Benefícios sociais (periódicos)',
  benefits_tab_flex_transactions: 'Transacções',
  benefits_export: 'Exportação',
  benefits_fetch_flex_budgets_error:
    'Ups! Algo correu mal ao tentar obter as opções de remuneração flexível do utilizador.',
  benefits_max_meal_allowed_surpased:
    'Só podem ser atribuídos montantes inferiores ou iguais ao limite de isenção atribuído ao utilizador.',
  benefits_transactions_fetch_transactions_error:
    'Ups! Algo correu mal ao tentar obter as transacções',
  benefits_export_benefits_error:
    'Ups! Algo correu mal ao exportar transacções',

  benefits_export_benefits_select_period: 'Seleccione o período a exportar',
  benefits_export_select_period: 'Período',
  benefits_fetch_export_periods_error:
    'Ups! Algo correu mal ao tentar obter os períodos de exportação.',

  /* Benefits configuration */
  office_feature_not_available:
    'Esta funcionalidade não está activa para o escritório actual',
  benefits_configuration: 'Configurar',
  benefits_configure_benefits_header: 'Configuração de benefícios',
  benefits_office_setting_update_success:
    'A configuração foi actualizada correctamente',
  benefits_office_setting_update_error:
    'Ups! Tivemos um problema ao tentar actualizar a configuração',
  benefits_toggle_all_users_features_status_success:
    'Mudámos correctamente o estatuto de todos os utilizadores',
  benefits_toggle_all_users_features_status_error:
    'Ups! Algo correu mal quando se tentou mudar o estatuto de benefício do empregado.',
  benefits_closure_date_invalid_value_error: 'Introduzir um dia válido',
  benefits_closure_data_value_not_in_range_error:
    'O dia que seleccionou é inválido, por favor introduza um dia entre 1 e 31.',
  benefits_closure_date_set_success:
    'O dia de encerramento foi fixado correctamente',
  benefits_set_closure_date_error:
    'Ups! Ocorreu um erro ao tentar indicar o dia de encerramento.',
  benefits_configuration_settings_accumulative_benefits:
    'Remuneração flexível acumulada',
  benefits_configuration_settings_activate_accumulative_benefits:
    'Activar a remuneração flexível acumulada para os utilizadores',
  benefits_configuration_settings_accumulative_benefits_explanation:
    'Se activado, o dinheiro não gasto pelo empregado no mês corrente será adicionado ao saldo do mês seguinte. Escreva para {support} para activar esta opção.',
  benefits_configuration_benefits_closure_date: 'Dia do mês',
  benefits_budget_benefit_reset_warning:
    'Indique o último dia do mês antes de os benefícios serem retomados.',
  benefits_configuration_setting_activate_on_all_users:
    'Activar para todos os utilizadores',
  benefits_configuration_configure_features_for_all_users_warning:
    'Só será activado para empregados a quem tenha sido atribuído o salário anual bruto, uma vez que é necessário para o cálculo do máximo legal. Pode indicar o salário anual bruto na secção do utilizador. Ao activarmos para todos atribuiremos uma aproximação ao máximo legal que corresponde ao utilizador.',
  benefits_configuration_setting_personalize_time_restrictions:
    'Horário de restrição',
  benefits_confirm_ret_flex_deactivation_with_accumulative_benefits:
    'Desactivar a remuneração flexível acumulada para este empregado',
  benefits_confirm_acumulation_removal_warning:
    'Este colaborador tem {balance} em {activityGroup}. Ao desactivar, não o poderá utilizar. Em vez de o desactivar, a partir de agora pode defini-lo para 0 euros, para que possa utilizar o saldo restante {balance}, mas não será adicionado um novo saldo à sua conta todos os meses. Ainda o pretende desactivar? conta todos os meses, ainda quer desactivá-lo?',
  benefits_confirm_acumulation_setting_removal_office_warning:
    'É possível que tenha colaboradores com saldo acumulado e, ao desactivá-lo, não o poderão utilizar. Em vez de o desactivar, pode fixar o subsídio mensal em 0 euros para que possam utilizar o saldo restante, mas não será acrescentado nenhum novo saldo à sua conta todos os meses. Ainda o pretende desactivar?onta todos os meses, mas ainda assim pretende desactivar?',
  benefits_confirm_acumulation_removal_action_confirm: 'Sim, quero desactivar',
  benefits_confirm_subvention_deactivation_with_accumulative_subvention:
    'Desactivar o subsídio acumulado para este empregado',
  benefits_confirm_acumulation_remove_warning:
    'Este empregado tem fundos numa das subvenções activas, ao desactivar, não poderá utilizá-los. Em vez de desactivar, a partir de agora pode definir para 0 euros, para que ele ainda possa utilizar os fundos atribuídos, mas não é adicionado nenhum novo saldo à sua conta todos os meses, mas ainda quer desactivar?',
  benefits_configuration_activate_feature:
    'Permitir que todos os utilizadores se candidatem',

  benefits_configuration_activate_warning__FLEXIBLE_REMUNERATION_NURSERY:
    'Ao activar esta opção, os colaboradores poderão fazer um pedido de pagamento flexível de cuidado de crianças através de um formulário que lhes será enviado pela Fuell. Assim que o utilizador fizer o pedido, notificá-lo-emos por e-mail para que possa aceitá-lo ou rejeitá-lo aceitá-lo ou negá-lo.',
  benefits_configuration_activate_warning__FLEXIBLE_REMUNERATION_INSURANCE:
    'Ao activar esta opção, os colaboradores poderão fazer um pedido de remuneração flexível do seguro através de um formulário que lhes será enviado pela Fuell. Assim que o utilizador fizer o pedido, notificá-lo-emos por e-mail para que possa aceitá-lo ou rejeitá-lo.egá-lo.',
  benefits_configuration_activate_warning__FLEXIBLE_REMUNERATION_EDUCATION:
    'Ao activar esta opção, os colaboradores poderão fazer um pedido de remuneração flexível de formação através de um formulário que lhes será enviado pela Fuell. Assim que o utilizador fizer o pedido, notificá-lo-emos por e-mail para que possa aceitá-lo ou rejeitá-lo. negá-lo.',

  snackbars_insurance_policy_holders_warning:
    'Deve indicar um titular de seguro a fim de alterar a atribuição.',
  /* - Benefits time restrictions configuration - */
  benefits_configure_time_restrictions: 'Configurar restrições de horário',
  benefits_header_time_restrictions: 'Restrições de horário de utilização',
  benefits_configuration_settings_time_restrictions_from_label:
    'Hora de início de utilização',
  benefits_configuration_settings_time_restrictions_to_label:
    'Tempo de fim de utilização',
  benefits_time_restrictions_configuration_modal:
    'Configurar restrições de horário',
  benefits_configuration_settings_time_restrictions:
    'Configurar restrições de horário para os utilizadores.',
  benefits_configurations_settings_time_restrictions_warning:
    'Defina quando os utilizadores podem utilizar os seus cartões. Fora destas restrições de tempo, os cartões não podem ser utilizados para pagar refeições ou transporte (independentemente de ser para remuneração flexível ou benefícios sociais). O Decreto-de-lei 439/2007 estabelece que a prestação do serviço (refeição) deve ter lugar nos dias úteis do trabalhador.o Real 439/2007 estabelece que a prestação do serviço (refeição) deve ter lugar nos dias úteis para o trabalhador ou empregado.',

  benefits_configurations_time_restrictions_weekdays:
    'Dias em que podem ser utilizados',
  benefits_configurations_time_restrictions_restricted_time:
    'Dias em que podem ser utilizados',
  benefits_configuration_time_restrictions_success:
    'As restrições de horário foram correctamente actualizadas',
  benefits_configuration_time_restrictions_error:
    'Ups! Tivemos um problema ao tentar actualizar as restrições de horário',
  benefits_configuration_time_from_after_to:
    'A hora de início não pode ser posterior à hora de fim de utilização.',
  benefits_configuration_time_to_before_from:
    'O tempo de fim de utilização não pode ser anterior ao tempo de início de utilização.',
  /* Flexible remuneration types */
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_MEAL:
    'Remuneração flexível de refeições',
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_TRANSPORT:
    'Remuneração flexível de transportes',
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_NURSERY:
    'Remuneração flexível de cuidado de crianças',

  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_EDUCATION:
    'Remuneração flexível de formação',
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_INSURANCE:
    'Remuneração flexível do seguro',

  benefits_configuration_closure_date_note: 'Nota: ',
  benefits_configuration_closure_date_last_closure:
    'o último encerramento teve lugar em {lastClosureDate}, ',
  benefits_configuration_closure_date_next_closure:
    'o próximo encerramento terá lugar em {nextClosureDate}.',
  benefits_table_header_current_month_fallback: 'Mês corrente',

  export_fields_InvoiceNumberLabel: 'Número da factura',
  export_fields_expenseDateLabel: 'Data da despesa',
  export_fields_expenseHourLabel: 'Hora da despesa',
  export_fields_balanceLabel: 'Saldo',
  export_fields_currencyBalanceLabel: 'Moeda',
  export_fields_amountSettledLabel: 'Montante pago',
  export_fields_currencySettledLabel: 'Moeda original',
  export_fields_amountApprovedLabel: 'Montante aprovado',
  export_fields_currencyApprovedLabel: 'Moeda aprovada',
  export_fields_merchantNameLabel: 'Comerciante',
  export_fields_businessNameNameLabel: 'Empresa',
  export_fields_merchantIdLabel: 'ID Comerciante',
  export_fields_merchantAddressLabel: 'Endereço comercial',
  export_fields_merchantZipCodeLabel: 'Comerciante Zip Code',
  export_fields_merchantProvinceLabel: 'Província Comerciante',
  export_fields_merchantRegionLabel: 'Comerciante Region',
  export_fields_merchantCountryLabel: 'merchantCountry',
  export_fields_taxationCountryLabel: 'país do IVA',
  export_fields_employeeNameLabel: 'NomeEmpregado',
  export_fields_originalCategoryLabel: 'Categoria',
  export_fields_subCategoryLabel: 'Subcategoria',
  export_fields_codeCategoryLabel: 'Código da categoria',
  export_fields_noteLabel: 'Nota',
  export_fields_reviewStatusLabel: 'Revisto',
  export_fields_mediaLabel: 'Média',
  export_fields_originalTaxLabel: 'Taxa de imposto',
  export_fields_netAmountLabel: 'Valor do imposto',
  export_fields_taxAmountLabel: 'Montante do imposto',
  export_fields_grossAmountLabel: 'Montante bruto',
  export_fields_budgetNameLabel: 'Nome do orçamento',
  export_fields_paymentMethodCodeLabel: 'Método de pagamento',
  export_fields_refundableLabel: 'Reembolsável',
  export_fields_isReceiptLabel: 'É um recibo?',
  export_fields_transactionStatusLabel: 'Status',
  export_fields_receiptTypeLabel: 'Receipt or invoice',
  export_fields_expenseCreatedAtLabel: 'Expense creation date',
  export_fields_receiptNumberLabel: 'Receipt number',
  export_fields_employeeIdentifierLabel: 'Employee identifier',
  export_fields_employeeExpenseCenterLabel: 'Expense Center',
  export_fields_transactionCreatedAtLabel: 'Transaction Creation Date',
  export_fields_transactionReviewedAtLabel: 'Data revista',
  export_fields_creditAmountLabel: 'Deve',
  export_fields_debitAmountLabel: 'Crédito',
  export_fields_IVALabel: 'IVA',
  export_fields_grossAmountEuroLabel: 'Montante bruto €',
  export_fields_confirmationDateLabel: 'Data de confirmação',
  export_fields_mediaLinkLabel: 'Ligação media',
  export_fields_transactionIdLabel: 'Identificador gasto',
  export_fields_taxType1Label: 'Taxa de imposto 1',
  export_fields_taxBase1Label: 'Base fiscal 1',
  export_fields_vat1Label: 'Montante do imposto 1',
  export_fields_taxType2Label: 'Taxa de imposto 2',
  export_fields_taxBase2Label: 'Base fiscal 2',
  export_fields_vat2Label: 'Montante do imposto 2',
  export_fields_taxType3Label: 'Taxa de imposto 3',
  export_fields_taxBase3Label: 'Base fiscal 3',
  export_fields_vat3Label: 'Montante do imposto 3',
  export_fields_taxType4Label: 'Taxa de imposto 4',
  export_fields_taxBase4Label: 'Base fiscal 4',
  export_fields_vat4Label: 'Montante do imposto 4',
  export_fields_taxType5Label: 'Taxa de imposto 5',
  export_fields_taxBase5Label: 'Base fiscal 5',
  export_fields_vat5Label: 'Montante do imposto 5',
  export_fields_taxType6Label: 'Taxa de imposto 6',
  export_fields_taxBase6Label: 'Base fiscal 6',
  export_fields_vat6Label: 'Montante do imposto 6',
  export_fields_budgetField1Label: 'Campo 1 do orçamento',
  export_fields_budgetField2Label: 'Campo 2 do orçamento',
  export_fields_budgetField3Label: 'Campo 3 do orçamento',
  export_fields_userDocumentLabel: 'Identificação pessoal',
  export_fields_vatTypeCodeLabel: 'Código fiscal',

  /* EXPORT FLOW */
  exports_create_export_flow_title: 'Ainda não tem quaisquer fluxos de exportação',
  exports_create_export_flow_subtitle: 'Os fluxos são a forma de configurar uma exportação para facilitar a sua realização numa base recorrente. Vamos criar o primeiro. Não se preocupe, felizmente é muito simples',
  exports_create_export_flow_button: 'Criar exportação',
  export_exportation_flow_name: 'Nome',
  export_exportation_flow_exportation_system: 'Sistema de exportação',
  export_exportation_flow_exportation_system_subtitle: 'Escolha onde são guardados s dados de exportação',
  export_exportation_flow_erp: 'ERP conectada',
  export_exportation_flow_erp_placeholder: 'ERP',
  export_exportation_flow_destination_file: 'Ficheiro de destino',
  export_exportation_flow_field_mapping: 'Mapeamento de campo',
  export_exportation_flow_field_mapping_subtitle: 'Que mapeamento de campo será utilizado?',
  export_exportation_flow_field_mapping_placeholder: 'Seleccione a partir da lista',
  export_exportation_flow_field_mapping_empty: 'Não utilizar o mapeamento de campo',
  export_export_flow_historical: 'Export_export_flow_historical',
  export_export_flow_historical_description: 'Maintain export history',
  export_export_flow_historical_info: 'Ao assinalar esta caixa não lhe serão mostradas despesas que tenham sido anteriormente exportadas',
  export_exportation_flow_entities_to_export: 'Entidades a exportar',
  export_exportation_flow_entities_to_export_NORMAL: 'Transacções',
  export_exportation_flow_entities_to_export_EXPENSE: 'Despesas',
  export_exportation_flow_initial_filters: 'Filtros_iniciais',
  export_exportation_flow_initial_filters_subtitle: 'Deseja aplicar um filtro por defeito ao aceder ao fluxo de exportação?',
  export_exportation_flow_initial_filters_ALL: 'Todos',
  export_exportation_flow_initial_filters_DENIED: 'Negado',
  export_exportation_flow_initial_filters_COMPLETED: 'Concluído',
  export_exportation_flow_initial_filters_APPROVED: 'Aprovado',
  export_exportation_flow_initial_filters_PERSONAL_EXPENSES: 'Despesas pessoais',
  export_exportation_flow_initial_filters_MISSING_INFO: 'Falta informação',
  export_exportation_flow_initial_filters_SEND_FOR_REVIEW: 'Em revisão',
  export_exportation_flow_initial_filters_DENIED_PERSONAL_EXPENSES: 'Negado/Despesas pessoais',
  export_exportation_flow_date: 'Data',
  export_exportation_flow_clear_dates: 'Selecção clara da data',
  export_exportation_flow_user_search: 'Seleccione um ou mais da lista',
  export_exportation_flow_budget_search: 'Seleccione um ou mais da lista',
  export_exportation_flow_file_format: 'Template',
  export_edit_exportation_flow_modal_header: 'Modificar fluxo de exportação',
  export_create_exportation_flow_modal_header: 'Novo fluxo de exportação',
  export_edit_exportation_flow_modal_confirm: 'Guardar',
  export_create_exportation_flow_modal_confirm: 'Guardar',
  export_exportation_flow_tabs_all: 'Todos',
  export_exportation_flow_tabs_transactions: 'Transacções',
  export_exportation_flow_tabs_expenses: 'Despesas',
  export_exportation_flow_using: 'A exportar',
  export_exportation_flow_using_placeholder: 'Seleccionar fluxo de exportação',
  export_flow_create_export_flow: '+ Novo fluxo de exportação',
  export_flow_modify: 'Modificar',
  export_flow_export: 'Exportar',
  export_exportation_flow_exported: 'Ir para Exportado',
  export_flow_exported_date: 'Data',
  export_flow_exported_exportation: 'Ir para Exportação',
  export_flow_exported_file: 'Ficheiro',
  export_flow_exported_filters: 'Filtros',
  export_flow_exported_format: 'Formato',
  export_flow_exported_status: 'Estado',
  export_exportation_flow_translate_filters_completed: 'Concluído',
  export_exportation_flow_translate_filters_status: 'Estado: ',
  export_exportation_flow_translate_filters_status_CANCELLED: 'Cancelado ',
  export_exportation_flow_translate_filters_status_APPROVED: 'Aprovado ',
  export_exportation_flow_translate_filters_personal_expense: 'Despesas de Pessoal',
  export_exportation_flow_translate_filters_date: 'Data: ',
  export_exportation_flow_translate_filters_entity_NORMAL: 'Entidade: Transacções',
  export_exportation_flow_translate_filters_entity_EXPENSE: 'Entidade: Despesas',
  export_exportation_flow_translate_filters_entity_ALL: 'Entidades: transacções e despesas',
  export_exportation_flow_translate_filters_budget: 'Orçamento: ',
  export_exportation_flow_translate_filters_user: 'Utilizadores: ',

  /* - Benefits Columns - */
  benefits_users_table_header_subvention_status: 'Benefício social activado',

  benefits_users_table_header_meals_current_month: 'Refeições: {currentMonth}',
  benefits_users_table_header_meals_next_months: 'Refeições: meses seguintes',
  benefits_users_table_header_transport_current_month:
    'Transporte: {currentMonth}',
  benefits_users_table_header_transport_next_months:
    'Transporte: meses seguintes',
  benefits_users_table_header_nursery_status: 'Cuidados infantis activados',
  benefits_users_table_header_insurance_status: 'Seguros activado',
  benefits_users_table_header_insurance_assignation: 'Seguros: atribuição',
  benefits_users_table_header_insurance_policy_holders: 'Seguros: manchetes',
  benefits_users_table_header_insurance_disabled_policy_holders:
    'Seguros: pessoas com deficiência',
  benefits_users_table_header_insurance_education_status: 'Formação activada',
  benefits_users_table_header_insurance_education_assignation:
    'Formação: atribuição',
  /* -------------- */
  /* - MERCHANT SETTINGS - */
  merchant_settings_merchant_settings_tab: 'Comércios',
  merchant_settings_actitvy_groups_settings_tab: 'Sectores de actividade',
  merchant_settings_merchant_create_button: 'Novo comércio',

  /* - Comerciante Settings Table - */
  merchant_merchant_name: 'Nome de exibição',
  merchant_merchant_social_reason: 'Nome da empresa',
  merchant_merchant_matchers: 'Filtros',
  merchant_merchant_add_matcher: 'Adicionar filtro',
  merchant_merchant_cif: ' IVA',
  merchant_merchant_identifiers: 'Identificadores internos',

  /* - Comerciante details  - */
  merchants_merchant_detail_header: 'Configuração do comércio',
  merchants_fetch_merchant_error:
    'Ups! Tivemos um problema ao obter a informação do comerciante.',
  merchants_update_logo_success:
    'O logótipo comercial foi actualizado correctamente',
  merchants_update_logo_error:
    'Ups! Tivemos um problema ao tentar actualizar o logótipo comercial.',
  merchants_update_merchant_success: 'O comércio foi actualizado com sucesso',
  merchants_update_merchant_error:
    'Ups! Tivemos um problema ao tentar actualizar o comércio',
  merchants_create_merchant_success: 'O comércio foi criado correctamente',
  merchants_create_merchant_error:
    'Ups! Tivemos um problema ao tentar criar o comércio',
  merchant_merchant_matcher_text: 'Contém o texto',
  merchant_merchant_matcher_text_case_insensitive_info:
    'Sem distinção entre letras maiúsculas e minúsculas',

  /* - Activity Groups  - */
  merchants_activity_group_header_name: 'Nome',
  merchants_fetch_activity_groups_error:
    'Ups! Tivemos um problema em obter a lista de sectores de actividade.',
  /* - Activity group detail - */
  merchants_activity_group_detail: 'Detalhe do sector de actividade',
  merchants_activity_group_name: 'Nome',
  merchants_activity_group_national_codes: 'Códigos nacionais',
  merchants_activity_group_international_codes: 'Códigos internacionais',
  merchants_fetch_activity_group_error:
    'Ups! Tivemos um problema ao tentar obter os detalhes deste sector de actividade.',
  merchants_update_activity_group_logo_success:
    'Logótipo do sector de actividade correctamente actualizado',
  merchants_update_activity_group_logo_error:
    'Ups! Tivemos um problema ao actualizar o logótipo do sector de actividade.',

  /* -------------- */
  superadmin_generate_otp_success:
    'Foi enviada uma Password de uma utilização  para o seu telefone, por favor verifique o seu SMS',
  superadmin_generate_otp_error:
    'Ups! Tivemos um problema ao gerar a sua palavra-passe temporária, por favor tente novamente.',
  superadmin_make_admin_confirm_title: 'Esta acção não é reversível, quer continuar?',
  superadmin_make_admin_success: 'Este utilizador é agora administrador',
  superadmin_make_admin_error: 'Não foi possível tornar este utilizador administrador',
  /* - GENERIC TERMS  --- */

  file_input_select_browse: 'Explorar',
  file_input_select_file: 'Seleccionar Ficheiros ...',
  file_input_amount_files_selected: '{amount} archivos seleccionados',
  media_viewer_fetch_resource: 'Descarregar',
  media_viewer_fetching_resource: 'A descarregar...',
  media_viewer_delete_resource: 'Eliminar',
  media_viewer_deleting_resource: 'A eliminar...',
  date_picker_input_placeholder: 'Seleccione um intervalo de datas',
  date_picker_input_expiration_date_select_default_date:
    'Sem data de validade',
  date_picker_input_transaction_date_range_selector: 'Datas da transacção',
  date_picker_input_from: 'Data de início',
  date_picker_input_to: 'Data final',
  date_picker_input_range_selector_placeholder:
    'Clique e seleccione a data de início e fim',
  date_picker_input_range_selector_range_selected:
    'De {startDate} a {endDate} inclusive',
  date_picker_select_range_selector_range_selected: '{startDate} a {endDate}',
  date_picker_input_placeholder_mask: 'MM/DD/YYY',
  date_invalid_error: 'Introduzir uma data válida',
  date_select_this_month: 'Mês corrente',
  date_select_last_month: 'Mês passado',
  date_select_this_year: 'Este ano',
  date_select_last_seven_days: 'Últimos 7 dias',
  date_select_personalized_range: 'Gama personalizada',
  date_select_personalized_range_from_to: 'a',
  snackbar_launch_intercom_message: 'Pergunte-nos via chat se precisar de ajuda',
  intercom_predefined_error_message:
    'Olá, recebi a seguinte mensagem de erro: " {errorMessage} ", Pode dar-me uma ajuda?',
  intercom_predefined_error_message_with_route:
    'Olá, recebi a seguinte mensagem de erro: " {errorMessage} " estar neste endereço : {routerUrl} ,  Pode dar-me uma ajuda?',
  intercom_open_conversation: 'Contacto por chat',
  intercom_import_users_message:
    'Olá, preciso de ajuda para importar utilizadores, podem dar-me uma ajuda?',
  intercom_reset_passcode_message:
    'Olá, preciso de recuperar a minha senha, pode dar-me uma ajuda?',
  intercom_message_variation_message:
    'Se precisar de ajuda, peça-nos via chat.',
  multiselect_no_options_slot_default: 'Não foram encontradas opções',
  multiselect_no_result_slot_default:
    'Não foram encontrados resultados, por favor tente novamente',
  multiselect_no_users_found: 'Nenhum utilizador encontrado',
  multiselect_no_users: 'Não há utilizadores disponíveis',
  multiselect_accounting_period_not_found: 'Nenhum período encontrado',

  multiselect_no_accounting_periods:
    'Não foram encontrados períodos contabilísticos',
  multiselect_payment_method_not_found: 'Não foram encontrados métodos de pagamento',
  multiselect_no_payment_methods: 'Não foram encontrados métodos de pagamento',
  multiselect_no_budgets_found: 'Não foram encontradas orçamentos',
  multiselect_no_budgets: 'Sem orçamentos criados',
  multiselect_no_categories_found: 'Não foram encontradas categorias',
  multiselect_limit_text: 'e {count} mais',
  error_handler_violation_field_message: '{fieldName}',

  route_redirection_role_notification:
    'Não tem permissões de acesso ao site que especificou',
  keyword_to_range: 'a',
  /* ------- */

  network_error_message:
    'Ups! Parece que estamos a ter problemas de ligação, por favor tente novamente dentro de alguns momentos ou recarregue a página.',
  /* - Validation Generic Messages - */
  validations_password_mismatch: 'As palavras-passe não coincidem',

  /* - Confirm Modal Text - */
  confirm_modal_title: 'Tem a certeza?',
  confirm_modal_message: 'Tem a certeza? Esta acção não pode ser desfeita',
  confirm_modal_accept_button_text: 'Sim',
  confirm_modal_dismiss_button_text: 'Cancelar',
  /* ------ */

  /* -- Card Usage Types -- */
  office_card_usage_type__OFFICE_CARDS_ALWAYS: 'Utilizadores de cartões',
  office_card_usage_type__OFFICE_CARDS_WITHOUT: 'Utilizadores sem cartão',
  office_card_usage_type__OFFICE_CARDS_OPTIONAL:
    'Utilizadores com cartão opcional',
  user_card_usage_type__USER_CARDS_ALWAYS: 'Pedir um cartão',
  user_card_usage_type__USER_CARDS_WITHOUT: 'Não solicitar um cartão',
  user_card_usage_not_applicable: 'Não aplicável',
  user_card_usage_type__PHYSICAL: 'Cartão físico',
  user_card_usage_type__VIRTUAL: 'Cartão virtual',

  /* -- Customer Statuses -- */
  customer_status__ACTIVE: 'Activo',
  customer_status__ARCHIVE: 'Arquivado',
  customer_status__KYB_REJECTED: 'KYB rejeitada',
  customer_status__ONBOARDING_PENDING: 'Pendente de sessão iniciada',
  customer_status__VALIDATION_PENDING: 'Pendente de validação',

  /* -  Activity Group  - */
  activity_group__RESTAURANTS: 'Refeição',
  activity_group__TRANSPORT: 'Transportes',
  activity_group__INSURANCE: 'Seguros',
  activity_group__NURSERY: 'Jardins-de-infância',
  activity_group__EDUCATION: 'Formação',
  activity_group__OTHERS: 'Outros',
  /* - Country Names- */
  Spain: 'Espanha',
  USA: 'Estados Unidos',
  country_name_Spain: 'Espanha',
  country_name_USA: 'Estados Unidos da América',
  /* -  Week days  - */
  day_of_week_0: 'Segunda-feira',
  day_of_week_1: 'Terça-feira',
  day_of_week_2: 'Quarta-feira',
  day_of_week_3: 'Quinta-feira',
  day_of_week_4: 'Sexta-feira',
  day_of_week_5: 'Sábado',
  day_of_week_6: 'Domingo',
  day_of_week_MONDAY: 'Segunda-feira',
  day_of_week_TUESDAY: 'Terça-feira',
  day_of_week_WEDNESDAY: 'Quarta-feira',
  day_of_week_THURSDAY: 'Quinta-feira',
  day_of_week_FRIDAY: 'Sexta-feira',
  day_of_week_SATURDAY: 'Sábado',
  day_of_week_SUNDAY: 'Domingo',

  /* CURRENCIES */
  currencies_EUR: 'EUR - EU Euro',
  currencies_GBP: 'GBP - British pound',
  currencies_USD: 'USD - US Dollar',
  currencies_ARS: 'ARS - Argentine peso',

  /* Other terms */
  EXPENSE: 'Despesa',
  REIMBURSEMENT: 'Despesa',
  TRANSACTION: 'Transacção',
  DIET: 'Refeição',
  MILEAGE: 'Quilómetro',
  snackbar_sanitizing_error: 'Foram introduzidos caracteres inválidos, por favor apague-os e tente novamente.',

  /* static pages */
  privacy_policy_page: 'https://www.getfuell.com/pt/politica-de-privacidade',
  terms_conditions_page: 'https://www.getfuell.com/pt/termos-do-site',
  special_conditions_services_page: 'https://www.getfuell.com/pt/condiciones-particulares-de-los-servicios',
  payment_terms_page: 'https://www.getfuell.com/pt/condiciones-del-proveedor-de-servicios-de-pago',

  // terms and conditions
  terms_conditions_title: 'Actualizámos os nossos termos e condições. Pode ver o documento completo no seguinte {tc}.',
  terms_conditions_description: 'Termos e condições actualizados',
  terms_conditions_description_link_text: 'link',
  terms_conditions_label: 'Li e aceito os novos Termos e Condições',
  terms_conditions_accept: 'Confirmar',

  /* alerts modal */
  alerts_modal_title: 'Alertas',
  alerts_modal_duplicated: 'Alerta de gastos duplicados',
  alerts_modal_duplicated_description: 'Alertá-lo-emos se detectarmos algum gasto duplicado. Terá sempre a capacidade de rever as despesas e ignorar o alerta',
  alerts_modal_empty_receipt: 'Alerta por falta de recibo',
  alerts_modal_empty_receipt_description: 'Alertá-lo-emos se qualquer despesa carregada para a plataforma não tiver um recibo associado',
  alerts_modal_out_of_office: 'Calendário de despesas',
  alerts_modal_out_of_office_description: 'Definir as horas durante as quais os empregados podem incorrer em despesas comerciais. Se um for feito fora destas horas, iremos notificá-lo',
  alerts_modal_amount_exceeded: 'Alerta para quantidade excedida',
  alerts_modal_amount_exceeded_description: 'É possível definir montantes máximos dependendo do tipo de despesa. Se qualquer despesa exceder esse montante, alertá-lo-emos',
  alerts_modal_AMOUNT_EXCEEDED_TRANSACTION: 'Despesa',
  alerts_modal_AMOUNT_EXCEEDED_EXPENSE: 'Despesa',
  alerts_modal_AMOUNT_EXCEEDED_MILEAGE_TYPE: 'Mileage',
  alerts_modal_AMOUNT_EXCEEDED_DIET: 'Dieta',
  alerts_modal_amount_distinct_ocr: 'Alerta para leitura de uma quantidade diferente',
  alerts_modal_amount_distinct_ocr_description: 'Se o nosso OCR ler no recibo um montante diferente do valor da transacção ou do montante inscrito pelo funcionário sobre a despesa, alertá-lo-emos.',
  alerts_modal_amount_distinct_sum_taxes: 'Alerta para base tributável incorrecta',
  alerts_modal_amount_distinct_sum_taxes_description: 'Se a repartição da matéria colectável, juntamente com o IVA correspondente, não corresponder ao montante pago, notificá-lo-emos.',

  company_update_alerts_settings_error: 'Oops! tivemos um problema em actualizar este tipo de alerta.',

  /* Drag and drop  */
  dropzone_drag_and_drop_files_info: 'Arrastar e largar as suas bilhetes',
  dropzone_drag_and_drop_files_upload_count: 'Carregamento de {fileCount} bilhetes...'

}
